
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
// 
// index.js
// Cacao
// 
// Created on 7/4/23
// 
var $27637818bf42bbb8$exports = {};
function $27637818bf42bbb8$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
$27637818bf42bbb8$var$$parcel$export($27637818bf42bbb8$exports, "Array", ()=>$27637818bf42bbb8$var$$24b828e2c0ac7de2$export$2e2bcd8739ae039);
$27637818bf42bbb8$var$$parcel$export($27637818bf42bbb8$exports, "assert", ()=>$27637818bf42bbb8$var$$2c78cbd652541061$export$a7a9523472993e97);
$27637818bf42bbb8$var$$parcel$export($27637818bf42bbb8$exports, "isEquivalent", ()=>$27637818bf42bbb8$var$$84c84b328e1b047d$export$2c3070a504066332);
$27637818bf42bbb8$var$$parcel$export($27637818bf42bbb8$exports, "pointee", ()=>$27637818bf42bbb8$var$$f6056fdcef89ff06$export$46838187e754e06c);
$27637818bf42bbb8$var$$parcel$export($27637818bf42bbb8$exports, "tree", ()=>$27637818bf42bbb8$var$$f6056fdcef89ff06$export$4767d4262788a6cc);
// 
// index.js
// Cacao
// 
// Created on 9/6/22
// 
// 
// Array.js
// Cacao
// 
// Created on 9/6/22
// 
// 
// Assertions.js
// Cacao
// 
// Created on 9/6/22
// 
function $27637818bf42bbb8$var$$2c78cbd652541061$export$a7a9523472993e97(condition, message) {
    if (!condition) throw new Error(message || "Assertion failed");
}
class $27637818bf42bbb8$var$$24b828e2c0ac7de2$var$_Array extends Array {
    copy() {
        return this.slice(0);
    }
    append(element) {
        $27637818bf42bbb8$var$$2c78cbd652541061$export$a7a9523472993e97(element, "`element` is required.");
        this.push(element);
    }
    appendContentsOf(array) {
        $27637818bf42bbb8$var$$2c78cbd652541061$export$a7a9523472993e97(array, "`array` is required.");
        $27637818bf42bbb8$var$$2c78cbd652541061$export$a7a9523472993e97(Array.isArray(array), "`array` needs to be an Array.");
        this.push(...array);
    }
    insertAt(element, index) {
        $27637818bf42bbb8$var$$2c78cbd652541061$export$a7a9523472993e97(element, "`element` is required.");
        $27637818bf42bbb8$var$$2c78cbd652541061$export$a7a9523472993e97(index >= 0 && index <= this.count, "`index` is out of bounds.");
        this.splice(index, 0, element); // insert `element` at index `index`.
    }
    removeFirst(element) {
        $27637818bf42bbb8$var$$2c78cbd652541061$export$a7a9523472993e97(element, "`element` is required.");
        const index = this.indexOf(element);
        if (index != -1) return this.splice(index, 1)[0];
        return undefined;
    }
    removeLast() {
        const count = this.count;
        if (count > 0) return this.removeAt(count - 1);
        return undefined;
    }
    removeAt(index) {
        $27637818bf42bbb8$var$$2c78cbd652541061$export$a7a9523472993e97(index >= 0 && index < this.count, "`index` is out of bounds.");
        if (index != -1) return this.splice(index, 1)[0];
        return undefined;
    }
    removeAll(whereFn) {
        if (whereFn) {
            const elements = this.filter((element, index)=>!whereFn(element, index));
            this.length = 0;
            this.push(...elements);
        } else this.length = 0;
    }
    swapAt(fromIndex, toIndex) {
        const count = this.count;
        $27637818bf42bbb8$var$$2c78cbd652541061$export$a7a9523472993e97(fromIndex >= 0 && fromIndex < count, "`fromIndex` is out of bounds.");
        $27637818bf42bbb8$var$$2c78cbd652541061$export$a7a9523472993e97(toIndex >= 0 && toIndex < count, "`toIndex` is out of bounds.");
        if (fromIndex == toIndex) return;
        this.splice(toIndex, 0, this.splice(fromIndex, 1)[0]);
    }
    contains(element) {
        $27637818bf42bbb8$var$$2c78cbd652541061$export$a7a9523472993e97(element, "`element` is required.");
        return this.indexOf(element) != -1;
    }
    get isEmpty() {
        return this.length <= 0;
    }
    get first() {
        const count = this.count;
        if (count > 0) return this[0];
        return undefined;
    }
    get last() {
        const count = this.count;
        if (count > 0) return this[count - 1];
        return undefined;
    }
    get count() {
        return this.length;
    }
}
var $27637818bf42bbb8$var$$24b828e2c0ac7de2$export$2e2bcd8739ae039 = $27637818bf42bbb8$var$$24b828e2c0ac7de2$var$_Array;
// 
// Equivalence.js
// Cacao
// 
// Created on 9/6/22
// 
function $27637818bf42bbb8$var$$84c84b328e1b047d$export$2c3070a504066332(a, b) {
    if (a === b) return true;
    if (typeof a != "object" || typeof b != "object" || a == null || b == null) return false;
    let keysA = Object.keys(a), keysB = Object.keys(b);
    if (keysA.length != keysB.length) return false;
    for (let key of keysA){
        if (!keysB.includes(key)) return false;
        if (typeof a[key] === "function" || typeof b[key] === "function") {
            if (a[key].toString() != b[key].toString()) return false;
        } else {
            if (!$27637818bf42bbb8$var$$84c84b328e1b047d$export$2c3070a504066332(a[key], b[key])) return false;
        }
    }
    return true;
}
// 
// Logging.js
// Cacao
// 
// Created on 9/6/22
// 
function $27637818bf42bbb8$var$$f6056fdcef89ff06$export$46838187e754e06c(instance) {
    let pointee;
    try {
        pointee = instance.constructor?.name || instance.toString();
    } catch  {
        pointee = "[Unknown]";
    }
    return pointee;
}
function $27637818bf42bbb8$var$$f6056fdcef89ff06$export$4767d4262788a6cc(root, name, children) {
    return new $27637818bf42bbb8$var$$f6056fdcef89ff06$var$TreeGrapher(name, children).parse(root);
}
class $27637818bf42bbb8$var$$f6056fdcef89ff06$var$TreeGrapher {
    constructor(name, children, limit = 1000){
        this.settings = {
            keyword: {
                name: name,
                children: children
            },
            maxLevel: limit
        };
    }
    setPre(level, hasNext, parentPre = "") {
        return `${parentPre}${hasNext ? "\u251C" : "\u2514"}\u{2500}\u{2500} `;
    }
    setTransferPre(parentPre = "", hasNext) {
        return `${parentPre}${hasNext ? "\u2502" : " "}   `;
    }
    parse(tree, level = 0, parentPre = "", treeStr = "") {
        if (!this.check(tree, level)) return "";
        if (Array.isArray(tree)) tree.forEach((child, index)=>{
            const hasNext = tree[index + 1] ? true : false;
            const children = child[this.settings.keyword.children];
            treeStr += `${this.setPre(level, hasNext, parentPre)}${child[this.settings.keyword.name]}\n`;
            if (children) treeStr += this.parse(children, level + 1, this.setTransferPre(parentPre, hasNext));
        });
        else {
            const children = tree[this.settings.keyword.children];
            treeStr = `${tree[this.settings.keyword.name]}\n`;
            if (children) treeStr += this.parse(children, level + 1);
        }
        return treeStr;
    }
    check(tree, level) {
        if (typeof tree !== "object") return false;
        if (level >= this.settings.maxLevel) return false;
        return true;
    }
}


// 
// App.js
// Cacao
// 
// Created on 8/23/22
// 

class $1553bf3484a166d1$var$App {
    #document;
    #readyState;
    #documentHasFinishedLoading = false;
    constructor(document){
        (0, $27637818bf42bbb8$exports.assert)(document, "A container `document` is required to use App.");
        this.#document = document;
        this.#attach();
    }
    documentReadyStateDidChange(document) {
    // Override if needed.
    }
    documentDidLoad(document) {
    // Override if needed.
    }
    #attach() {
        const document = this.#document;
        const handleDocumentState = ()=>{
            if (this.#readyState != document.readyState) {
                this.#readyState = document.readyState;
                this.documentReadyStateDidChange(document);
            }
            switch(document.readyState){
                case "loaded":
                case "complete":
                case "interactive":
                    // The document has finished loading. We can now access the DOM elements.
                    if (!this.#documentHasFinishedLoading) {
                        this.#documentHasFinishedLoading = true;
                        this.documentDidLoad(document);
                    }
                    break;
            }
        };
        handleDocumentState();
        if (!this.#documentHasFinishedLoading) document.addEventListener("readystatechange", handleDocumentState);
    }
    get document() {
        return this.#document;
    }
}
var $1553bf3484a166d1$export$2e2bcd8739ae039 = $1553bf3484a166d1$var$App;


// 
// View.js
// Cacao
// 
// Created on 8/23/22
// 
// 
// index.js
// Cacao
// 
// Created on 9/6/22
// 
// 
// Array.js
// Cacao
// 
// Created on 9/6/22
// 
// 
// Assertions.js
// Cacao
// 
// Created on 9/6/22
// 
function $5868598d1aabdccb$export$a7a9523472993e97(condition, message) {
    if (!condition) throw new Error(message || "Assertion failed");
}


class $e59551ef346ff73a$var$_Array extends Array {
    copy() {
        return this.slice(0);
    }
    append(element) {
        (0, $5868598d1aabdccb$export$a7a9523472993e97)(element, "`element` is required.");
        this.push(element);
    }
    appendContentsOf(array) {
        (0, $5868598d1aabdccb$export$a7a9523472993e97)(array, "`array` is required.");
        (0, $5868598d1aabdccb$export$a7a9523472993e97)(Array.isArray(array), "`array` needs to be an Array.");
        this.push(...array);
    }
    insertAt(element, index) {
        (0, $5868598d1aabdccb$export$a7a9523472993e97)(element, "`element` is required.");
        (0, $5868598d1aabdccb$export$a7a9523472993e97)(index >= 0 && index <= this.count, "`index` is out of bounds.");
        this.splice(index, 0, element); // insert `element` at index `index`.
    }
    removeFirst(element) {
        (0, $5868598d1aabdccb$export$a7a9523472993e97)(element, "`element` is required.");
        const index = this.indexOf(element);
        if (index != -1) return this.splice(index, 1)[0];
        return undefined;
    }
    removeLast() {
        const count = this.count;
        if (count > 0) return this.removeAt(count - 1);
        return undefined;
    }
    removeAt(index) {
        (0, $5868598d1aabdccb$export$a7a9523472993e97)(index >= 0 && index < this.count, "`index` is out of bounds.");
        if (index != -1) return this.splice(index, 1)[0];
        return undefined;
    }
    removeAll(whereFn) {
        if (whereFn) {
            const elements = this.filter((element, index)=>!whereFn(element, index));
            this.length = 0;
            this.push(...elements);
        } else this.length = 0;
    }
    swapAt(fromIndex, toIndex) {
        const count = this.count;
        (0, $5868598d1aabdccb$export$a7a9523472993e97)(fromIndex >= 0 && fromIndex < count, "`fromIndex` is out of bounds.");
        (0, $5868598d1aabdccb$export$a7a9523472993e97)(toIndex >= 0 && toIndex < count, "`toIndex` is out of bounds.");
        if (fromIndex == toIndex) return;
        this.splice(toIndex, 0, this.splice(fromIndex, 1)[0]);
    }
    contains(element) {
        (0, $5868598d1aabdccb$export$a7a9523472993e97)(element, "`element` is required.");
        return this.indexOf(element) != -1;
    }
    get isEmpty() {
        return this.length <= 0;
    }
    get first() {
        const count = this.count;
        if (count > 0) return this[0];
        return undefined;
    }
    get last() {
        const count = this.count;
        if (count > 0) return this[count - 1];
        return undefined;
    }
    get count() {
        return this.length;
    }
}
var $e59551ef346ff73a$export$2e2bcd8739ae039 = $e59551ef346ff73a$var$_Array;



// 
// Equivalence.js
// Cacao
// 
// Created on 9/6/22
// 
function $a277ea0f99f667f4$export$2c3070a504066332(a, b) {
    if (a === b) return true;
    if (typeof a != "object" || typeof b != "object" || a == null || b == null) return false;
    let keysA = Object.keys(a), keysB = Object.keys(b);
    if (keysA.length != keysB.length) return false;
    for (let key of keysA){
        if (!keysB.includes(key)) return false;
        if (typeof a[key] === "function" || typeof b[key] === "function") {
            if (a[key].toString() != b[key].toString()) return false;
        } else {
            if (!$a277ea0f99f667f4$export$2c3070a504066332(a[key], b[key])) return false;
        }
    }
    return true;
}


// 
// Logging.js
// Cacao
// 
// Created on 9/6/22
// 
function $bade16267cea3bd0$export$46838187e754e06c(instance) {
    let pointee;
    try {
        pointee = instance.constructor?.name || instance.toString();
    } catch  {
        pointee = "[Unknown]";
    }
    return pointee;
}
function $bade16267cea3bd0$export$4767d4262788a6cc(root, name, children) {
    return new $bade16267cea3bd0$var$TreeGrapher(name, children).parse(root);
}
class $bade16267cea3bd0$var$TreeGrapher {
    constructor(name, children, limit = 1000){
        this.settings = {
            keyword: {
                name: name,
                children: children
            },
            maxLevel: limit
        };
    }
    setPre(level, hasNext, parentPre = "") {
        return `${parentPre}${hasNext ? "\u251C" : "\u2514"}\u{2500}\u{2500} `;
    }
    setTransferPre(parentPre = "", hasNext) {
        return `${parentPre}${hasNext ? "\u2502" : " "}   `;
    }
    parse(tree, level = 0, parentPre = "", treeStr = "") {
        if (!this.check(tree, level)) return "";
        if (Array.isArray(tree)) tree.forEach((child, index)=>{
            const hasNext = tree[index + 1] ? true : false;
            const children = child[this.settings.keyword.children];
            treeStr += `${this.setPre(level, hasNext, parentPre)}${child[this.settings.keyword.name]}\n`;
            if (children) treeStr += this.parse(children, level + 1, this.setTransferPre(parentPre, hasNext));
        });
        else {
            const children = tree[this.settings.keyword.children];
            treeStr = `${tree[this.settings.keyword.name]}\n`;
            if (children) treeStr += this.parse(children, level + 1);
        }
        return treeStr;
    }
    check(tree, level) {
        if (typeof tree !== "object") return false;
        if (level >= this.settings.maxLevel) return false;
        return true;
    }
}




class $75862b29e2b1753f$var$View {
    #node;
    #subviews = new (0, $e59551ef346ff73a$export$2e2bcd8739ae039)();
    #superview;
    #isNodeLoaded = false;
    constructor(){
    //
    }
    makeNode(document1) {
        return document1.createElement("div");
    }
    addSubview(subview1) {
        this.insertSubview(subview1, this.#subviews.length);
    }
    insertSubviewBelow(subview1, siblingSubview) {
        (0, $5868598d1aabdccb$export$a7a9523472993e97)(subview1 !== siblingSubview, `Attempted to insert subview "${(0, $bade16267cea3bd0$export$46838187e754e06c)(subview1)}" as a sibling that is the same view.`);
        this.insertSubview(subview1, this.#subviews.indexOf(siblingSubview));
    }
    insertSubviewAbove(subview1, siblingSubview) {
        (0, $5868598d1aabdccb$export$a7a9523472993e97)(subview1 !== siblingSubview, `Attempted to insert subview "${(0, $bade16267cea3bd0$export$46838187e754e06c)(subview1)}" as a sibling that is the same view.`);
        this.insertSubview(subview1, this.#subviews.indexOf(siblingSubview) + 1);
    }
    insertSubview(subview1, index) {
        (0, $5868598d1aabdccb$export$a7a9523472993e97)(subview1, `Attempted to insert undefined subview at index ${index}`);
        (0, $5868598d1aabdccb$export$a7a9523472993e97)(subview1 instanceof $75862b29e2b1753f$var$View, `Attempted to insert invalid subview "${(0, $bade16267cea3bd0$export$46838187e754e06c)(subview1)}" at index ${index}" that's not a View.`);
        (0, $5868598d1aabdccb$export$a7a9523472993e97)(subview1 != this, `Attempted to insert view "${(0, $bade16267cea3bd0$export$46838187e754e06c)(subview1)}" as a subview of itself.`);
        (0, $5868598d1aabdccb$export$a7a9523472993e97)((index)=>0, `Attempted to insert subview "${(0, $bade16267cea3bd0$export$46838187e754e06c)(subview1)}" at invalid index ${index}"`);
        (0, $5868598d1aabdccb$export$a7a9523472993e97)(index != -1, "Index cannot be -1.");
        if (subview1.superview !== this) subview1.removeFromSuperview();
        try {
            const { node: node } = this;
            const { childNodes: childNodes } = node;
            if (index >= childNodes.length) node.appendChild(subview1.node);
            else node.insertBefore(subview1.node, childNodes[index].node);
        } catch (error) {
            throw new Error(`Couldn't perform DOM hierarchy change when inserting view "${(0, $bade16267cea3bd0$export$46838187e754e06c)(subview1)}". Document may be in an inconsistent state.`, {
                cause: error
            });
        }
        this.#subviews.insertAt(subview1, index);
        subview1.#superview = this;
    }
    removeFromSuperview() {
        const { superview: superview } = this;
        if (superview) {
            superview.#removeSubview(this);
            return;
        }
        if (this.isNodeLoaded) {
            const { node: node } = this;
            const { parentNode: parentNode } = node;
            if (parentNode) parentNode.removeChild(node);
        }
    }
    isDescendantOfView(view) {
        (0, $5868598d1aabdccb$export$a7a9523472993e97)(view, `The view to test against the receiver cannot be undefined.`);
        (0, $5868598d1aabdccb$export$a7a9523472993e97)(subview instanceof $75862b29e2b1753f$var$View, `The view to test against the receiver "${(0, $bade16267cea3bd0$export$46838187e754e06c)(subview)}" is not a View.`);
        const visit = (viewToTest)=>{
            if (viewToTest == view) return true;
            const parent = viewToTest.superview;
            return parent ? visit(parent) : false;
        };
        return visit(this);
    }
    #removeSubview(subview1) {
        (0, $5868598d1aabdccb$export$a7a9523472993e97)(subview1, "Subview is required.");
        this.#subviews.removeFirst(subview1);
        if (subview1.isNodeLoaded) subview1.node.remove();
    }
    // Node
    makeNodeIfNeeded() {
        if (this.#isNodeLoaded) return;
        // TODO: Support passing custom `document` instance, shadow DOM?
        let node;
        try {
            node = this.makeNode(document);
        } catch  {
            throw new Error("A DOM node couldn't be materialized for this View.");
        }
        (0, $5868598d1aabdccb$export$a7a9523472993e97)(node, "The result of -makeNode() must return a DOM node for this View.");
        (0, $5868598d1aabdccb$export$a7a9523472993e97)(node instanceof Node, "A DOM node must be an instance of Node.");
        this.#node = node;
        this.#isNodeLoaded = true;
    }
    // Getters
    get isNodeLoaded() {
        return this.#isNodeLoaded;
    }
    get node() {
        this.makeNodeIfNeeded();
        (0, $5868598d1aabdccb$export$a7a9523472993e97)(this.#node, "The node shouldn't be undefined at this point.");
        return this.#node;
    }
    get subviews() {
        return this.#subviews.copy();
    }
    get superview() {
        return this.#superview;
    }
}
var $75862b29e2b1753f$export$2e2bcd8739ae039 = $75862b29e2b1753f$var$View;


// 
// RootView.js
// Cacao
// 
// Created on 8/23/22
// 


class $7f8792a5bdbc7afc$var$RootView extends (0, $75862b29e2b1753f$export$2e2bcd8739ae039) {
    #container;
    constructor(container){
        super();
        (0, $27637818bf42bbb8$exports.assert)(container, "A `container` is required.");
        (0, $27637818bf42bbb8$exports.assert)(container instanceof HTMLElement, "`container` is not an HTMLElement.");
        this.#container = container;
        this.attach();
    }
    get container() {
        return this.#container;
    }
    attach() {
        try {
            this.#container.appendChild(this.node);
        } catch  {
            throw new Error(`Failed to connect RootView to container.`);
        }
    }
    detach() {
        const parent = this.node.parent;
        if (parent) parent.removeChild(this.node);
    }
}
var $7f8792a5bdbc7afc$export$2e2bcd8739ae039 = $7f8792a5bdbc7afc$var$RootView;


// 
// Canvas2DView.js
// Cacao
// 
// Created on 9/8/22
// 

var $ba5a447b6ce1696c$exports = {};
function $ba5a447b6ce1696c$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
$ba5a447b6ce1696c$var$$parcel$export($ba5a447b6ce1696c$exports, "Interpolation", ()=>$ba5a447b6ce1696c$var$$e3e2971203022b54$export$2e2bcd8739ae039);
$ba5a447b6ce1696c$var$$parcel$export($ba5a447b6ce1696c$exports, "RubberBanding", ()=>$ba5a447b6ce1696c$var$$47bfed8c5aa73889$export$2e2bcd8739ae039);
$ba5a447b6ce1696c$var$$parcel$export($ba5a447b6ce1696c$exports, "Rect", ()=>$ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$c79fc6492f3af13d);
$ba5a447b6ce1696c$var$$parcel$export($ba5a447b6ce1696c$exports, "Size", ()=>$ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$cb6da89c6af1a8ec);
$ba5a447b6ce1696c$var$$parcel$export($ba5a447b6ce1696c$exports, "Point", ()=>$ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$baf26146a414f24a);
$ba5a447b6ce1696c$var$$parcel$export($ba5a447b6ce1696c$exports, "Edge", ()=>$ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$b9d9805c9b77a56d);
$ba5a447b6ce1696c$var$$parcel$export($ba5a447b6ce1696c$exports, "EdgeInsets", ()=>$ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$45cce0bd6c1f342a);
$ba5a447b6ce1696c$var$$parcel$export($ba5a447b6ce1696c$exports, "Path2D", ()=>$ba5a447b6ce1696c$var$$e2b259e740dd748e$export$2e2bcd8739ae039);
// 
// index.js
// Cacao
// 
// Created on 7/4/23
// 
// 
// Geometry.js
// Cacao
// 
// Created on 9/8/22
// 
class $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$c79fc6492f3af13d {
    origin = $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$baf26146a414f24a.zero;
    size = $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$cb6da89c6af1a8ec.zero;
    static make(x, y, width, height) {
        return new $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$c79fc6492f3af13d(new $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$baf26146a414f24a(x, y), new $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$cb6da89c6af1a8ec(width, height));
    }
    static from(rect) {
        if (!rect) return undefined;
        return $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$c79fc6492f3af13d.make(rect.origin.x, rect.origin.y, rect.size.width, rect.size.height);
    }
    static get zero() {
        return $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$c79fc6492f3af13d.make(0, 0, 0, 0);
    }
    static get null() {
        return $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$c79fc6492f3af13d.make(Infinity, Infinity, 0, 0);
    }
    constructor(origin, size){
        this.origin = $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$baf26146a414f24a.from(origin);
        this.size = $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$cb6da89c6af1a8ec.from(size);
    }
    equals(rect) {
        rect = $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$c79fc6492f3af13d.from(rect);
        return this.origin.x == rect.origin.x && this.origin.y == rect.origin.y && this.size.width == rect.size.width && this.size.height == rect.size.height;
    }
    copy() {
        return $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$c79fc6492f3af13d.make(this.origin.x, this.origin.y, this.size.width, this.size.height);
    }
    offsetBy(dx, dy) {
        return $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$c79fc6492f3af13d.make(this.origin.x + dx, this.origin.y + dy, this.size.width, this.size.height);
    }
    insetBy(dx, dy) {
        return $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$c79fc6492f3af13d.make(this.origin.x + dx, this.origin.y + dy, this.size.width - 2 * dx, this.size.height - 2 * dy);
    }
    insetByEdgeInsets(edgeInsets) {
        edgeInsets = $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$45cce0bd6c1f342a.from(edgeInsets);
        return $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$c79fc6492f3af13d.make(this.origin.x + edgeInsets.left, this.origin.y + edgeInsets.top, this.size.width - edgeInsets.left - edgeInsets.right, this.size.height - edgeInsets.top - edgeInsets.bottom);
    }
    divide(slice, remainder, amount, edge) {
        slice.origin = this.origin.copy();
        slice.size = this.size.copy();
        remainder.origin = this.origin.copy();
        remainder.size = this.size.copy();
        switch(edge){
            case $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$b9d9805c9b77a56d.minX:
                slice.size.width = amount;
                remainder.origin.x += amount;
                remainder.size.width -= amount;
                break;
            case $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$b9d9805c9b77a56d.maxX:
                slice.origin.x = $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$c79fc6492f3af13d.from(slice).maxX - amount;
                slice.size.width = amount;
                remainder.size.width -= amount;
                break;
            case $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$b9d9805c9b77a56d.minY:
                slice.size.height = amount;
                remainder.origin.y += amount;
                remainder.size.height -= amount;
                break;
            case $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$b9d9805c9b77a56d.maxY:
                slice.origin.y = $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$c79fc6492f3af13d.from(slice).maxY - amount;
                slice.size.height = amount;
                remainder.size.height -= amount;
                break;
        }
    }
    containsPoint(aPoint) {
        return aPoint.x >= this.origin.x && aPoint.y >= this.origin.y && aPoint.x < this.maxX && aPoint.y < this.maxY;
    }
    containsRect(rect) {
        const union = this.union(rect);
        return this.equals(union);
    }
    intersects(rect) {
        const intersection = this.intersection(rect);
        return !intersection.isEmpty;
    }
    intersection(rect) {
        rect = $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$c79fc6492f3af13d.from(rect);
        const intersection = $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$c79fc6492f3af13d.make(Math.max(this.minX, rect.minX), Math.max(this.minY, rect.minY), 0, 0);
        intersection.size.width = Math.min(this.maxX, rect.maxX) - intersection.minX;
        intersection.size.height = Math.min(this.maxY, rect.maxY) - intersection.minY;
        return intersection.isEmpty ? $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$c79fc6492f3af13d.zero : intersection;
    }
    union(rect) {
        rect = $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$c79fc6492f3af13d.from(rect);
        const thisIsNull = this.isNull, rectIsNull = !rect || rect.isNull;
        if (thisIsNull) return rectIsNull ? $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$c79fc6492f3af13d.null : rect;
        if (rectIsNull) return thisIsNull ? $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$c79fc6492f3af13d.null : this.copy();
        const minX = Math.min(this.minX, rect.minX), minY = Math.min(this.minY, rect.minY), maxX = Math.max(this.maxX, rect.maxX), maxY = Math.max(this.maxY, rect.maxY);
        return $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$c79fc6492f3af13d.make(minX, minY, maxX - minX, maxY - minY);
    }
    get standarized() {
        const { width: width, height: height } = this;
        const standardized = this.copy();
        if (width < 0.0) {
            standardized.origin.x += width;
            standardized.size.width = -width;
        }
        if (height < 0.0) {
            standardized.origin.y += height;
            standardized.size.height = -height;
        }
        return standardized;
    }
    get integral() {
        const rect = this.standarized;
        const x = Math.floor(this.minX), y = Math.floor(this.minY);
        aRect.size.width = Math.ceil(this.maxX) - x;
        aRect.size.height = Math.ceil(this.maxY) - y;
        aRect.origin.x = x;
        aRect.origin.y = y;
        return aRect;
    }
    get width() {
        return this.size.width;
    }
    set width(width) {
        this.size.width = width;
    }
    get height() {
        return this.size.height;
    }
    set height(height) {
        this.size.height = height;
    }
    get x() {
        return this.origin.x;
    }
    set x(x) {
        this.origin.x = x;
    }
    get y() {
        return this.origin.y;
    }
    set y(y) {
        this.origin.y = y;
    }
    get maxX() {
        return this.origin.x + this.size.width;
    }
    get maxY() {
        return this.origin.y + this.size.height;
    }
    get midX() {
        return this.origin.x + this.size.width / 2.0;
    }
    get midY() {
        return this.origin.y + this.size.height / 2.0;
    }
    get minX() {
        return this.origin.x;
    }
    get minY() {
        return this.origin.y;
    }
    get isEmpty() {
        return this.size.width <= 0.0 || this.size.height <= 0.0 || this.origin.x === Infinity || this.origin.y === Infinity;
    }
    get isNull() {
        return this.origin.x === Infinity || this.origin.y === Infinity;
    }
    toString() {
        return `{${this.origin}, ${this.size}}`;
    }
}
class $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$baf26146a414f24a {
    x = 0;
    y = 0;
    static get zero() {
        return new $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$baf26146a414f24a(0, 0);
    }
    static from(point) {
        return !point ? $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$baf26146a414f24a.zero : $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$baf26146a414f24a.make(point.x, point.y);
    }
    static make(x, y) {
        return new $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$baf26146a414f24a(x, y);
    }
    constructor(x, y){
        this.x = x;
        this.y = y;
    }
    equals(point) {
        return this.x == point.x && this.y == point.y;
    }
    copy() {
        return new $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$baf26146a414f24a(this.x, this.y);
    }
    toString() {
        return `{${this.x}, ${this.y}}`;
    }
}
class $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$cb6da89c6af1a8ec {
    width = 0;
    height = 0;
    static get zero() {
        return new $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$cb6da89c6af1a8ec(0, 0);
    }
    static from(size) {
        return !size ? undefined : $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$cb6da89c6af1a8ec.make(size.width, size.height);
    }
    static make(width, height) {
        return new $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$cb6da89c6af1a8ec(width, height);
    }
    constructor(width, height){
        this.width = width;
        this.height = height;
    }
    equals(size) {
        return this.width == size.width && this.height == size.height;
    }
    copy() {
        return new $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$cb6da89c6af1a8ec(this.width, this.height);
    }
    toString() {
        return `{${this.width}, ${this.height}}`;
    }
}
class $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$b9d9805c9b77a56d {
    static minX() {
        return 0;
    }
    static minY() {
        return 1;
    }
    static maxX() {
        return 2;
    }
    static maxY() {
        return 3;
    }
}
class $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$45cce0bd6c1f342a {
    top = 0;
    left = 0;
    bottom = 0;
    right = 0;
    static get zero() {
        return new $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$45cce0bd6c1f342a(0, 0, 0, 0);
    }
    static from(edgeInsets) {
        return !edgeInsets ? undefined : $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$45cce0bd6c1f342a.make(edgeInsets.top, edgeInsets.left, edgeInsets.bottom, edgeInsets.right);
    }
    static make(top, left, bottom, right) {
        return new $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$45cce0bd6c1f342a(top, left, bottom, right);
    }
    constructor(top = 0, left = 0, bottom = 0, right = 0){
        this.top = top;
        this.left = left;
        this.bottom = bottom;
        this.right = right;
    }
    equals(edgeInsets) {
        const { top: top, left: left, bottom: bottom, right: right } = this;
        return top == edgeInsets.top && left == edgeInsets.left && bottom == edgeInsets.bottom && right == edgeInsets.right;
    }
    copy() {
        const { top: top, left: left, bottom: bottom, right: right } = this;
        return new $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$45cce0bd6c1f342a(top, left, bottom, right);
    }
}
// 
// Interpolation.js
// Cacao
// 
// Created on 6/8/23
// 
function $ba5a447b6ce1696c$var$$e3e2971203022b54$var$lerp(x, y, a) {
    return x * (1 - a) + y * a;
}
function $ba5a447b6ce1696c$var$$e3e2971203022b54$var$clamp(a, min = 0, max = 1) {
    return Math.min(max, Math.max(min, a));
}
function $ba5a447b6ce1696c$var$$e3e2971203022b54$var$invlerp(a, b, value) {
    return (value - a) / (b - a);
}
function $ba5a447b6ce1696c$var$$e3e2971203022b54$var$range(x1, y1, x2, y2, a) {
    return $ba5a447b6ce1696c$var$$e3e2971203022b54$var$lerp(x2, y2, $ba5a447b6ce1696c$var$$e3e2971203022b54$var$invlerp(x1, y1, a));
}
var $ba5a447b6ce1696c$var$$e3e2971203022b54$export$2e2bcd8739ae039 = {
    lerp: $ba5a447b6ce1696c$var$$e3e2971203022b54$var$lerp,
    clamp: $ba5a447b6ce1696c$var$$e3e2971203022b54$var$clamp,
    range: $ba5a447b6ce1696c$var$$e3e2971203022b54$var$range,
    invlerp: $ba5a447b6ce1696c$var$$e3e2971203022b54$var$invlerp
};
// 
// RubberBanding.js
// Cacao
// 
// Created on 5/8/23
// 
function $ba5a447b6ce1696c$var$$47bfed8c5aa73889$var$clampedValueUsingRubberBandingParameters(value, parameters) {
    const { coeff: coeff = 0.55, dim: dim } = parameters;
    return (1.0 - 1.0 / (value * coeff / dim + 1.0)) * dim;
}
var $ba5a447b6ce1696c$var$$47bfed8c5aa73889$export$2e2bcd8739ae039 = {
    clamp: $ba5a447b6ce1696c$var$$47bfed8c5aa73889$var$clampedValueUsingRubberBandingParameters
};
// 
// Path2D.js
// Cacao
// 
// Created on 9/9/22
// 
class $ba5a447b6ce1696c$var$$e2b259e740dd748e$var$_Path2D extends Path2D {
    roundedRect(x, y, width, height, cornerRadius, roundedCornerStyle) {
        const rect = $ba5a447b6ce1696c$var$$4d2286c4c2bf13cd$export$c79fc6492f3af13d.make(x, y, width, height);
        const { minX: minX, minY: minY, maxX: maxX, maxY: maxY } = rect;
        switch(roundedCornerStyle){
            case "continous":
                const limit = Math.min(width, height) / 2 / 1.52866483;
                const limitedRadius = Math.min(cornerRadius, limit);
                const TOP_LEFT = (x, y)=>{
                    return [
                        minX + x * limitedRadius,
                        minY + y * limitedRadius
                    ];
                };
                const TOP_RIGHT = (x, y)=>{
                    return [
                        maxX - x * limitedRadius,
                        minX + y * limitedRadius
                    ];
                };
                const BOTTOM_RIGHT = (x, y)=>{
                    return [
                        maxX - x * limitedRadius,
                        maxY - y * limitedRadius
                    ];
                };
                const BOTTOM_LEFT = (x, y)=>{
                    return [
                        minX + x * limitedRadius,
                        maxY - y * limitedRadius
                    ];
                };
                const { moveTo: moveTo, lineTo: lineTo, bezierCurveTo: bezierCurveTo } = this;
                moveTo.apply(this, TOP_LEFT(1.52866483, 0.00000000));
                lineTo.apply(this, TOP_RIGHT(1.52866471, 0.00000000));
                bezierCurveTo.apply(this, [].concat(TOP_RIGHT(1.08849323, 0.00000000), TOP_RIGHT(0.86840689, 0.00000000), TOP_RIGHT(0.66993427, 0.06549600)));
                lineTo.apply(this, TOP_RIGHT(0.63149399, 0.07491100));
                bezierCurveTo.apply(this, [].concat(TOP_RIGHT(0.37282392, 0.16905899), TOP_RIGHT(0.16906013, 0.37282401), TOP_RIGHT(0.07491176, 0.63149399)));
                bezierCurveTo.apply(this, [].concat(TOP_RIGHT(0.00000000, 0.86840701), TOP_RIGHT(0.00000000, 1.08849299), TOP_RIGHT(0.00000000, 1.52866483)));
                lineTo.apply(this, BOTTOM_RIGHT(0.00000000, 1.52866471));
                bezierCurveTo.apply(this, [].concat(BOTTOM_RIGHT(0.00000000, 1.08849323), BOTTOM_RIGHT(0.00000000, 0.86840689), BOTTOM_RIGHT(0.06549569, 0.66993493)));
                lineTo.apply(this, BOTTOM_RIGHT(0.07491111, 0.63149399));
                bezierCurveTo.apply(this, [].concat(BOTTOM_RIGHT(0.16905883, 0.37282392), BOTTOM_RIGHT(0.37282392, 0.16905883), BOTTOM_RIGHT(0.63149399, 0.07491111)));
                bezierCurveTo.apply(this, [].concat(BOTTOM_RIGHT(0.86840689, 0.00000000), BOTTOM_RIGHT(1.08849323, 0.00000000), BOTTOM_RIGHT(1.52866471, 0.00000000)));
                lineTo.apply(this, BOTTOM_LEFT(1.52866483, 0.00000000));
                bezierCurveTo.apply(this, [].concat(BOTTOM_LEFT(1.08849299, 0.00000000), BOTTOM_LEFT(0.86840701, 0.00000000), BOTTOM_LEFT(0.66993397, 0.06549569)));
                lineTo.apply(this, BOTTOM_LEFT(0.63149399, 0.07491111));
                bezierCurveTo.apply(this, [].concat(BOTTOM_LEFT(0.37282401, 0.16905883), BOTTOM_LEFT(0.16906001, 0.37282392), BOTTOM_LEFT(0.07491100, 0.63149399)));
                bezierCurveTo.apply(this, [].concat(BOTTOM_LEFT(0.00000000, 0.86840689), BOTTOM_LEFT(0.00000000, 1.08849323), BOTTOM_LEFT(0.00000000, 1.52866471)));
                lineTo.apply(this, TOP_LEFT(0.00000000, 1.52866483));
                bezierCurveTo.apply(this, [].concat(TOP_LEFT(0.00000000, 1.08849299), TOP_LEFT(0.00000000, 0.86840701), TOP_LEFT(0.06549600, 0.66993397)));
                lineTo.apply(this, TOP_LEFT(0.07491100, 0.63149399));
                bezierCurveTo.apply(this, [].concat(TOP_LEFT(0.16906001, 0.37282401), TOP_LEFT(0.37282401, 0.16906001), TOP_LEFT(0.63149399, 0.07491100)));
                bezierCurveTo.apply(this, [].concat(TOP_LEFT(0.86840701, 0.00000000), TOP_LEFT(1.08849299, 0.00000000), TOP_LEFT(1.52866483, 0.00000000)));
                break;
            default:
                if (width < 2 * cornerRadius) cornerRadius = width / 2;
                if (height < 2 * cornerRadius) cornerRadius = height / 2;
                this.moveTo(x + cornerRadius, minY);
                this.arcTo(maxX, minY, maxX, maxY, cornerRadius);
                this.arcTo(maxX, maxY, minX, maxY, cornerRadius);
                this.arcTo(minX, maxY, minX, minY, cornerRadius);
                this.arcTo(minX, minY, maxX, minY, cornerRadius);
                break;
        }
        this.closePath();
    }
}
var $ba5a447b6ce1696c$var$$e2b259e740dd748e$export$2e2bcd8739ae039 = $ba5a447b6ce1696c$var$$e2b259e740dd748e$var$_Path2D;



class $9d9c9f916c716294$var$Canvas2DView extends (0, $75862b29e2b1753f$export$2e2bcd8739ae039) {
    #options = {
        width: 1,
        height: 1,
        scale: 0
    };
    #dirtyRect;
    #displayRequestID;
    makeNode(document) {
        return document.createElement("canvas");
    }
    drawRect(rect) {
    // override to render
    }
    setNeedsDisplay() {
        this.#dirtyRect = (0, $ba5a447b6ce1696c$exports.Rect).null;
        this.#scheduleDisplay();
    }
    setNeedsDisplayInRect(rect) {
        (0, $27637818bf42bbb8$exports.assert)(rect, "A rect must be passed.");
        rect = (0, $ba5a447b6ce1696c$exports.Rect).from(rect);
        this.#dirtyRect = this.#dirtyRect?.union(rect) || rect;
        this.#scheduleDisplay();
    }
    #scheduleDisplay() {
        const view = this;
        if (this.#displayRequestID) return;
        this.#displayRequestID = window.requestAnimationFrame(function BROWSER_IS_CALLING_OUT_TO_CANVAS2DVIEW_REQUEST_ANIMATION_FRAME_CALLBACK() {
            view.#displayRequestID = undefined;
            view.#display();
        });
    }
    #display() {
        const { node: node, options: options, context: context } = this;
        const { width: width, height: height, scale: scale } = options;
        const bounds = (0, $ba5a447b6ce1696c$exports.Rect).make(0, 0, width, height);
        // Scale context:
        const scaled = scale != 1;
        if (scaled) {
            context.save();
            context.scale(scale, scale);
        }
        // Calculate dirty rect. If rect is null, refresh the entire bounds of the canvas:
        let dirtyRect = this.#dirtyRect?.copy();
        if (!dirtyRect || dirtyRect.isNull) dirtyRect = bounds;
        // Intersect so we don't draw outside of bounds:
        dirtyRect = bounds.intersection(dirtyRect);
        // Clear entire bounds if `dirtyRect` is actually the whole view.
        // Maybe this should be a property.
        if (dirtyRect.equals(bounds)) context.clearRect(0, 0, width, height);
        // Call drawRect():
        this.drawRect(dirtyRect);
        // Restore context:
        if (scaled) context.restore();
        this.#dirtyRect = undefined;
    }
    set options(options) {
        let { width: width, height: height, scale: scale } = options;
        (0, $27637818bf42bbb8$exports.assert)(width && height, "`width` and `height` are required options.");
        if (!scale || scale <= 0.01) scale = window.devicePixelRatio;
        this.#options = {
            width: width,
            height: height,
            scale: scale
        };
        const { node: node } = this;
        node.width = width * scale;
        node.height = height * scale;
        node.style.width = `${width}px`;
        node.style.height = `${height}px`;
        this.setNeedsDisplay();
    }
    get options() {
        const { width: width, height: height, scale: scale } = this.#options;
        return {
            width: width,
            height: height,
            scale: scale
        };
    }
    get context() {
        return this.node.getContext("2d");
    }
}
var $9d9c9f916c716294$export$2e2bcd8739ae039 = $9d9c9f916c716294$var$Canvas2DView;


// 
// index.js
// Cacao
// 
// Created on 7/6/23
// 
// 
// GestureRecognizer.js
// Cacao
// 
// Created on 6/2/23
// 
// 
// Touch.js
// Cacao
// 
// Created on 5/8/23
// 
class $7a418fcf08526eb7$var$Touch {
    constructor(){
        this.x = 0;
        this.y = 0;
        this.tapCount = 0;
    }
}
var $7a418fcf08526eb7$export$2e2bcd8739ae039 = $7a418fcf08526eb7$var$Touch;


// 
// TouchType.js
// Cacao
// 
// Created on 6/17/23
// 
class $f83981078758ac76$var$TouchType {
    static direct = 0;
    static indirect = 1;
    static pen = 2;
}
var $f83981078758ac76$export$2e2bcd8739ae039 = $f83981078758ac76$var$TouchType;


// 
// GestureRecognizerState.js
// Cacao
// 
// Created on 6/2/23
// 
class $0d409e98add6de65$var$GestureRecognizerState {
    static possible = 0;
    static began = 1;
    static changed = 2;
    static ended = 3;
    static cancelled = 4;
    static failed = 5;
    static recognized = $0d409e98add6de65$var$GestureRecognizerState.ended;
}
var $0d409e98add6de65$export$2e2bcd8739ae039 = $0d409e98add6de65$var$GestureRecognizerState;


class $d835ab54782b41e2$var$GestureRecognizer {
    enabled;
    didChange;
    shouldBegin;
    constructor(){
        this._state = (0, $0d409e98add6de65$export$2e2bcd8739ae039).possible;
        this._touches = [];
        this.enabled = true;
    }
    reset() {
        this._state = (0, $0d409e98add6de65$export$2e2bcd8739ae039).possible;
        this._event = undefined;
    }
    set state(state) {
        if (this.shouldBegin && this._state == (0, $0d409e98add6de65$export$2e2bcd8739ae039).possible && (state == (0, $0d409e98add6de65$export$2e2bcd8739ae039).recognized || state == (0, $0d409e98add6de65$export$2e2bcd8739ae039).began)) {
            if (!this.shouldBegin(this)) state = (0, $0d409e98add6de65$export$2e2bcd8739ae039).failed;
        }
        const allowedStateTransitions = [
            // Discrete gestures:
            [
                (0, $0d409e98add6de65$export$2e2bcd8739ae039).possible,
                (0, $0d409e98add6de65$export$2e2bcd8739ae039).recognized,
                true
            ],
            [
                (0, $0d409e98add6de65$export$2e2bcd8739ae039).possible,
                (0, $0d409e98add6de65$export$2e2bcd8739ae039).failed,
                false
            ],
            // Continuous gestures:
            [
                (0, $0d409e98add6de65$export$2e2bcd8739ae039).possible,
                (0, $0d409e98add6de65$export$2e2bcd8739ae039).began,
                true
            ],
            [
                (0, $0d409e98add6de65$export$2e2bcd8739ae039).began,
                (0, $0d409e98add6de65$export$2e2bcd8739ae039).changed,
                true
            ],
            [
                (0, $0d409e98add6de65$export$2e2bcd8739ae039).began,
                (0, $0d409e98add6de65$export$2e2bcd8739ae039).cancelled,
                true
            ],
            [
                (0, $0d409e98add6de65$export$2e2bcd8739ae039).began,
                (0, $0d409e98add6de65$export$2e2bcd8739ae039).ended,
                true
            ],
            [
                (0, $0d409e98add6de65$export$2e2bcd8739ae039).changed,
                (0, $0d409e98add6de65$export$2e2bcd8739ae039).changed,
                true
            ],
            [
                (0, $0d409e98add6de65$export$2e2bcd8739ae039).changed,
                (0, $0d409e98add6de65$export$2e2bcd8739ae039).cancelled,
                true
            ],
            [
                (0, $0d409e98add6de65$export$2e2bcd8739ae039).changed,
                (0, $0d409e98add6de65$export$2e2bcd8739ae039).ended,
                true
            ]
        ];
        let transition;
        for (const [fromState, toState, notify] of allowedStateTransitions)if (fromState == this._state && toState == state) {
            transition = {
                fromState: fromState,
                toState: toState,
                notify: notify
            };
            break;
        }
        if (!transition) throw new Error(`GestureRecognizer: Invalid state transition from ${this._state} to ${state}.`);
        if (transition) {
            this._state = state;
            if (transition.notify && this.didChange) this.didChange(this);
        }
    }
    get state() {
        return this._state;
    }
    get event() {
        return this._event;
    }
    began(touches, event) {
    //
    }
    moved(touches, event) {
    //
    }
    ended(touches, event) {
    //
    }
    cancelled(touches, event) {
    //
    }
    handleEvent(event) {
        // For now, only single-touch (and mouse) events are supported:
        if (!event.isPrimary) return;
        this._event = event;
        const touch = new (0, $7a418fcf08526eb7$export$2e2bcd8739ae039)();
        touch.identifier = event.pointerId;
        touch.x = event.clientX;
        touch.y = event.clientY;
        touch.tapCount = 1; // TODO
        if (event.pointerType) switch(event.pointerType){
            case "mouse":
                touch.type = (0, $f83981078758ac76$export$2e2bcd8739ae039).indirect;
                break;
            case "pen":
                touch.type = (0, $f83981078758ac76$export$2e2bcd8739ae039).pen;
                break;
            case "touch":
                touch.type = (0, $f83981078758ac76$export$2e2bcd8739ae039).direct;
                break;
            default:
                touch.type = (0, $f83981078758ac76$export$2e2bcd8739ae039).indirect;
                break;
        }
        else touch.type = (0, $f83981078758ac76$export$2e2bcd8739ae039).indirect;
        if (event.type == "pointerdown") {
            const continueTrackingOnWindow = true; // Expose this behavior?
            const target = continueTrackingOnWindow ? window : event.currentTarget;
            target.addEventListener("pointermove", this);
            target.addEventListener("pointerup", this);
            target.addEventListener("pointercancel", this);
            this._currentTarget = target;
        }
        const touches = [
            touch
        ];
        this._touches = touches;
        // Deliver touches if the gesture has not yet failed.
        if (this.state != (0, $0d409e98add6de65$export$2e2bcd8739ae039).failed) switch(event.type){
            case "pointerdown":
                this.began(touches, event);
                break;
            case "pointermove":
                this.moved(touches, event);
                break;
            case "pointerup":
                this.ended(touches, event);
                break;
            case "pointercancel":
                this.cancelled(touches, event);
                break;
        }
        switch(event.type){
            case "pointerup":
            case "pointercancel":
                const target = this._currentTarget;
                target.removeEventListener("pointermove", this);
                target.removeEventListener("pointerup", this);
                target.removeEventListener("pointercancel", this);
                this.reset();
                break;
        }
    }
    attach(target) {
        target.addEventListener("pointerdown", this);
    }
    locationInView(view) {
        // TODO: Convert to view coordinates.
        const touch = this._touches[0];
        if (touch) {
            const { x: x, y: y } = touch;
            return {
                x: x,
                y: y
            };
        }
        return undefined;
    }
    touchesInView(view) {
        // TODO: Return touches for the view.
        return this._touches.slice(0);
    }
    canPreventGestureRecognizer(preventingGestureRecognizer) {
        return true;
    }
    canBePreventedByGestureRecognizer(preventedGestureRecognizer) {
        return true;
    }
}
var $d835ab54782b41e2$export$2e2bcd8739ae039 = $d835ab54782b41e2$var$GestureRecognizer;



// 
// PanGestureRecognizer.js
// Cacao
// 
// Created on 5/8/23
// 


class $e0ae29d71a91a327$var$PanGestureRecognizer extends (0, $d835ab54782b41e2$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this._touchesSamplingQueue = [];
    }
    set translation(value) {
        this._initialTouchPosition = value;
        this._latestTouchPosition = value;
    }
    get translation() {
        let x = 0, y = 0;
        const initial = this._initialTouchPosition, latest = this._latestTouchPosition;
        if (initial && latest) {
            x = latest.x - initial.x;
            y = latest.y - initial.y;
        }
        return {
            x: x,
            y: y
        };
    }
    get velocity() {
        this.dequeueSampledTouchesBeforeInterval(1000);
        const queue = this._touchesSamplingQueue;
        if (queue.length < 2) return {
            x: 0,
            y: 0
        };
        const first = queue[0], last = queue[queue.length - 1];
        const distance = {
            x: last.position.x - first.position.x,
            y: last.position.y - first.position.y
        };
        const time = (last.time - first.time) / 1000;
        return {
            x: distance.x / time,
            y: distance.y / time
        };
    }
    // - Sampling touches
    addSampleForTouchPosition(position) {
        this._touchesSamplingQueue.push({
            position: position,
            time: Date.now()
        });
        this.dequeueSampledTouchesBeforeInterval(50);
    }
    dequeueSampledTouchesBeforeInterval(duration) {
        const queue = this._touchesSamplingQueue;
        const expiration = Date.now() - duration;
        while(queue.length && queue[0].time < expiration)queue.shift();
    }
    updateLatestTouchPosition(position, event) {
        position = {
            x: position.x,
            y: position.y
        };
        this._latestTouchPosition = position;
        this.addSampleForTouchPosition(position);
    }
    // - State overrides
    reset() {
        super.reset();
        this._latestTouchPosition = undefined;
        this._initialTouchPosition = undefined;
        this._touchesSamplingQueue.splice(0);
    }
    began(touches, event) {
        if (this.state == (0, $0d409e98add6de65$export$2e2bcd8739ae039).possible) {
            this._initialTouchPosition = {
                x: touches[0].x,
                y: touches[0].y
            };
            this.state = (0, $0d409e98add6de65$export$2e2bcd8739ae039).began;
        }
    }
    moved(touches, event) {
        this.updateLatestTouchPosition(touches[0], event);
        this.state = (0, $0d409e98add6de65$export$2e2bcd8739ae039).changed;
    }
    ended(touches, event) {
        if (this.state == (0, $0d409e98add6de65$export$2e2bcd8739ae039).began || this.state == (0, $0d409e98add6de65$export$2e2bcd8739ae039).changed) {
            this.updateLatestTouchPosition(touches[0], event);
            this.state = (0, $0d409e98add6de65$export$2e2bcd8739ae039).ended;
        }
    }
    cancelled(touches, event) {
        if (this.state == (0, $0d409e98add6de65$export$2e2bcd8739ae039).began || this.state == (0, $0d409e98add6de65$export$2e2bcd8739ae039).changed) this.state = (0, $0d409e98add6de65$export$2e2bcd8739ae039).cancelled;
    }
}
var $e0ae29d71a91a327$export$2e2bcd8739ae039 = $e0ae29d71a91a327$var$PanGestureRecognizer;


// 
// TapGestureRecognizer.js
// Cacao
// 
// Created on 6/8/23
// 


class $890fe1ec12e520f9$var$TapGestureRecognizer extends (0, $d835ab54782b41e2$export$2e2bcd8739ae039) {
    numberOfTapsRequired = 1;
    numberOfTouchesRequired = 1;
    canPreventGestureRecognizer(preventingGestureRecognizer) {
        if (preventingGestureRecognizer instanceof $890fe1ec12e520f9$var$TapGestureRecognizer) return preventingGestureRecognizer.numberOfTapsRequired > this.numberOfTapsRequired;
        else return super.canPreventGestureRecognizer(preventingGestureRecognizer);
    }
    canBePreventedByGestureRecognizer(preventedGestureRecognizer) {
        if (preventedGestureRecognizer instanceof $890fe1ec12e520f9$var$TapGestureRecognizer) return preventedGestureRecognizer.numberOfTapsRequired <= this.numberOfTapsRequired;
        else return super.canBePreventedByGestureRecognizer(preventedGestureRecognizer);
    }
    began(touches) {
        const touch = touches[0];
        if (touch.tapCount >= this.numberOfTapsRequired) {
            if (this.state == (0, $0d409e98add6de65$export$2e2bcd8739ae039).possible) this.state = (0, $0d409e98add6de65$export$2e2bcd8739ae039).began;
            else if (this.state == (0, $0d409e98add6de65$export$2e2bcd8739ae039).began) this.state = (0, $0d409e98add6de65$export$2e2bcd8739ae039).changed;
        }
    }
    moved(touches) {
        if (this.state == (0, $0d409e98add6de65$export$2e2bcd8739ae039).began || this.state == (0, $0d409e98add6de65$export$2e2bcd8739ae039).changed) this.state = (0, $0d409e98add6de65$export$2e2bcd8739ae039).cancelled;
    }
    ended(touches) {
        if (this.state == (0, $0d409e98add6de65$export$2e2bcd8739ae039).began || this.state == (0, $0d409e98add6de65$export$2e2bcd8739ae039).changed) this.state = (0, $0d409e98add6de65$export$2e2bcd8739ae039).ended;
    }
    cancelled(touches) {
        if (this.state == (0, $0d409e98add6de65$export$2e2bcd8739ae039).began || this.state == (0, $0d409e98add6de65$export$2e2bcd8739ae039).changed) this.state = (0, $0d409e98add6de65$export$2e2bcd8739ae039).cancelled;
    }
}
var $890fe1ec12e520f9$export$2e2bcd8739ae039 = $890fe1ec12e520f9$var$TapGestureRecognizer;






// 
// index.js
// Cacao
// 
// Created on 7/6/23
// 
// 
// AnimatedProperty.js
// Cacao
// 
// Created on 5/8/23
// 
class $ff409bc474e7092d$var$AnimatedProperty {
    constructor(key, fromValue, toValue, timing){
        if (!key) throw "AnimatedProperty: Cannot animate a property without a key.";
        const f = this.parseValue(fromValue), t = this.parseValue(toValue);
        if (!t.unit) t.unit = f.unit; // assume `fromValue` unit if not present.
        if (!(!f.unit && !t.unit || f.unit === t.unit)) throw `AnimatedProperty: Unit for values mismatch. Animating from "${f.unit}" to "${t.unit}" is not supported.`;
        this.fromValue = f.floatValue;
        this.toValue = t.floatValue;
        this.unit = f.unit;
        this.key = key;
        this.timing = timing;
    }
    parseValue(value) {
        let floatValue = 0.0, unit = undefined;
        if (typeof value === "string" || value instanceof String) {
            floatValue = parseFloat(value);
            unit = value.match(/[\d.\-\+]*\s*(.*)/)[1] || "";
        } else if (!isNaN(value)) floatValue = value;
        return {
            unit: unit,
            floatValue: floatValue
        };
    }
    get reversed() {
        return new $ff409bc474e7092d$var$AnimatedProperty(this.key, this.toValue, this.fromValue, this.timing);
    }
}
var $ff409bc474e7092d$export$2e2bcd8739ae039 = $ff409bc474e7092d$var$AnimatedProperty;


// 
// PropertyAnimator.js
// Cacao
// 
// Created on 5/4/23
// 


// 
// SpringTimingParameters.js
// Cacao
// 
// Created on 5/8/23
// 
const { sqrt: $eb4fc4a00fc6fb7d$var$sqrt, exp: $eb4fc4a00fc6fb7d$var$exp, cos: $eb4fc4a00fc6fb7d$var$cos, sin: $eb4fc4a00fc6fb7d$var$sin, cosh: $eb4fc4a00fc6fb7d$var$cosh, sinh: $eb4fc4a00fc6fb7d$var$sinh } = Math;
class $eb4fc4a00fc6fb7d$var$SpringTimingParameters {
    constructor(options = {}){
        const { damping: damping = 10, mass: mass = 1, stiffness: stiffness = 100, initialVelocity: initialVelocity = {
            dx: 0,
            dy: 0
        } } = options;
        this.damping = damping;
        this.mass = mass;
        this.stiffness = stiffness;
        this.initialVelocity = initialVelocity;
    }
    copy() {
        const { damping: damping, mass: mass, stiffness: stiffness, initialVelocity: initialVelocity } = this;
        return new $eb4fc4a00fc6fb7d$var$SpringTimingParameters({
            damping: damping,
            mass: mass,
            stiffness: stiffness,
            initialVelocity: initialVelocity
        });
    }
    copyTimingFunction(options = {}) {
        const { damping: b, mass: m, stiffness: k } = this;
        const v0 = this.#initialVelocityForVelocityAxis(options.velocityAxis);
        return (t)=>{
            const beta = b / (2.0 * m);
            const omega0 = $eb4fc4a00fc6fb7d$var$sqrt(k / m);
            const omega1 = $eb4fc4a00fc6fb7d$var$sqrt(omega0 * omega0 - beta * beta);
            const omega2 = $eb4fc4a00fc6fb7d$var$sqrt(beta * beta - omega0 * omega0);
            const x0 = -1;
            const envelope = $eb4fc4a00fc6fb7d$var$exp(-beta * t);
            let fraction;
            if (beta < omega0) fraction = -x0 + envelope * (x0 * $eb4fc4a00fc6fb7d$var$cos(omega1 * t) + (beta * x0 + v0) / omega1 * $eb4fc4a00fc6fb7d$var$sin(omega1 * t));
            else if (beta == omega0) fraction = -x0 + envelope * (x0 + (beta * x0 + v0) * t);
            else fraction = -x0 + envelope * (x0 * $eb4fc4a00fc6fb7d$var$cosh(omega2 * t) + (beta * x0 + v0) / omega2 * $eb4fc4a00fc6fb7d$var$sinh(omega2 * t));
            return fraction;
        };
    }
    #initialVelocityForVelocityAxis(axis) {
        switch(axis){
            case $eb4fc4a00fc6fb7d$var$SpringTimingParameters.VelocityAxis.x:
                return this.initialVelocity.dx;
            case $eb4fc4a00fc6fb7d$var$SpringTimingParameters.VelocityAxis.y:
                return this.initialVelocity.dy;
            default:
                return 0;
        }
    }
    static get VelocityAxis() {
        return {
            x: 1,
            y: 2
        };
    }
}
var $eb4fc4a00fc6fb7d$export$2e2bcd8739ae039 = $eb4fc4a00fc6fb7d$var$SpringTimingParameters;


var $78e7515453ca2290$exports = {};

$parcel$export($78e7515453ca2290$exports, "linear", () => $78e7515453ca2290$export$45db2fc2f15997e7);
$parcel$export($78e7515453ca2290$exports, "easeInQuad", () => $78e7515453ca2290$export$2d59ca22077f6eab);
$parcel$export($78e7515453ca2290$exports, "easeOutQuad", () => $78e7515453ca2290$export$be35423d31ba201e);
$parcel$export($78e7515453ca2290$exports, "easeInOutQuad", () => $78e7515453ca2290$export$42add3d9cb3645a2);
$parcel$export($78e7515453ca2290$exports, "easeInCubic", () => $78e7515453ca2290$export$5da70c9577229d30);
$parcel$export($78e7515453ca2290$exports, "easeOutCubic", () => $78e7515453ca2290$export$1157fb72e7fbceb5);
$parcel$export($78e7515453ca2290$exports, "easeInOutCubic", () => $78e7515453ca2290$export$24656b269d8df7d6);
$parcel$export($78e7515453ca2290$exports, "easeInQuart", () => $78e7515453ca2290$export$c3d8280971f5e7ab);
$parcel$export($78e7515453ca2290$exports, "easeOutQuart", () => $78e7515453ca2290$export$fb9e4320a4025f10);
$parcel$export($78e7515453ca2290$exports, "easeInOutQuart", () => $78e7515453ca2290$export$bd93209e120f4915);
$parcel$export($78e7515453ca2290$exports, "easeInQuint", () => $78e7515453ca2290$export$d5a2637b851d40fa);
$parcel$export($78e7515453ca2290$exports, "easeOutQuint", () => $78e7515453ca2290$export$54ef52175ef1a966);
$parcel$export($78e7515453ca2290$exports, "easeInOutQuint", () => $78e7515453ca2290$export$40df750f1044ce5e);
// 
// TimingCurve.js
// Cacao
// 
// Created on 5/8/23
// 
const $78e7515453ca2290$export$45db2fc2f15997e7 = (t)=>{
    return t;
};
const $78e7515453ca2290$export$2d59ca22077f6eab = (t)=>{
    return t * t;
};
const $78e7515453ca2290$export$be35423d31ba201e = (t)=>{
    return t * (2 - t);
};
const $78e7515453ca2290$export$42add3d9cb3645a2 = (t)=>{
    return t < .5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
};
const $78e7515453ca2290$export$5da70c9577229d30 = (t)=>{
    return t * t * t;
};
const $78e7515453ca2290$export$1157fb72e7fbceb5 = (t)=>{
    return --t * t * t + 1;
};
const $78e7515453ca2290$export$24656b269d8df7d6 = (t)=>{
    return t < .5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
};
const $78e7515453ca2290$export$c3d8280971f5e7ab = (t)=>{
    return t * t * t * t;
};
const $78e7515453ca2290$export$fb9e4320a4025f10 = (t)=>{
    return 1 - --t * t * t * t;
};
const $78e7515453ca2290$export$bd93209e120f4915 = (t)=>{
    return t < .5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
};
const $78e7515453ca2290$export$d5a2637b851d40fa = (t)=>{
    return t * t * t * t * t;
};
const $78e7515453ca2290$export$54ef52175ef1a966 = (t)=>{
    return 1 + --t * t * t * t * t;
};
const $78e7515453ca2290$export$40df750f1044ce5e = (t)=>{
    return t < .5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
};


class $1c98d5f0dd1e30db$var$PropertyAnimator {
    constructor(options = {}){
        const { autoreverses: autoreverses = true, repeatCount: repeatCount = 0, interruptAnimationEvents: interruptAnimationEvents = [] } = options;
        if (options.timingParameters) this.timing = options.timingParameters.copy();
        else if (options.timingCurve) this.timing = {
            copyTimingFunction: ()=>options.timingCurve
        };
        else this.timing = {
            copyTimingFunction: ()=>$78e7515453ca2290$export$24656b269d8df7d6
        };
        this.autoreverses = autoreverses;
        this.repeatCount = repeatCount;
        this.interruptAnimationEvents = [
            "mousewheel",
            "touchstart"
        ] + interruptAnimationEvents;
    }
    animate(target, to, duration, completion) {
        if (!target) throw "PropertyAnimator: Cannot instantiate an animator without a target.";
        if (this.animating) this.stopAnimation();
        let properties1;
        const createAnimationForKey = (key, flags)=>{
            const fromValue = target[key], toValue = to[key];
            if (fromValue != toValue) {
                const timing = this.timing.copyTimingFunction(flags);
                return new (0, $ff409bc474e7092d$export$2e2bcd8739ae039)(key, fromValue, toValue, timing);
            }
            return undefined;
        };
        const { x: x, y: y } = (0, $eb4fc4a00fc6fb7d$export$2e2bcd8739ae039).VelocityAxis;
        if (to instanceof (0, $ba5a447b6ce1696c$exports.Point)) properties1 = [
            createAnimationForKey("x", {
                velocityAxis: x
            }),
            createAnimationForKey("y", {
                velocityAxis: y
            })
        ].filter(Boolean);
        else if (to instanceof (0, $ba5a447b6ce1696c$exports.Size)) properties1 = [
            createAnimationForKey("width", {
                velocityAxis: x
            }),
            createAnimationForKey("height", {
                velocityAxis: y
            })
        ].filter(Boolean);
        else if (to instanceof (0, $ba5a447b6ce1696c$exports.Rect)) properties1 = [
            createAnimationForKey("origin.x", {
                velocityAxis: x
            }),
            createAnimationForKey("origin.y", {
                velocityAxis: y
            }),
            createAnimationForKey("size.width", {
                velocityAxis: x
            }),
            createAnimationForKey("size.height", {
                velocityAxis: y
            })
        ].filter(Boolean);
        else {
            properties1 = [];
            for(const key in to){
                const property = createAnimationForKey(key);
                if (property) properties1.push(property);
            }
        }
        this.target = target;
        this.duration = Math.max(duration, 0.1);
        this.beginTime = 0.0;
        this.properties = properties1;
        this.completion = completion;
        this.completed = false;
        this.startAnimation();
    }
    update() {
        if (this.beginTime == 0.0) this.beginTime = new Date().getTime();
        else {
            let deltaTime = new Date().getTime() - this.beginTime;
            let progress = deltaTime / this.duration;
            let target = this.target;
            this.updateTarget(progress);
        }
    }
    updateTarget(progress) {
        const target = this.target;
        function out(value, unit) {
            if (unit) value = String(value) + unit;
            return value;
        }
        function set(object, keyPath, value) {
            let components = keyPath.split("."), componentsCount = components.length;
            if (componentsCount > 1) {
                let count = componentsCount - 1;
                for(let idx = 0; idx < count; idx += 1)object = object[components[idx]];
            }
            let lastPathComponent = componentsCount > 0 ? components[componentsCount - 1] : keyPath;
            object[lastPathComponent] = value;
            return object;
        }
        if (progress < 1.0) {
            if (1 - progress < 0.001) {
                for (const property of this.properties)set(target, property.key, out(property.toValue, property.unit));
                this.complete();
            } else for (const property of this.properties){
                const percent = property.timing(progress);
                const value = property.fromValue + (property.toValue - property.fromValue) * percent;
                set(target, property.key, out(value, property.unit));
            }
        } else {
            for (const property of this.properties)set(target, property.key, out(property.toValue, property.unit));
            this.complete();
        }
    }
    complete() {
        let iteration = this.iterationCount + 1;
        let completed = iteration > this.repeatCount;
        if (!completed) {
            this.beginTime = 0.0;
            if (this.autoreverses) {
                const reversed = [];
                for (const property of properties)reversed.push(property.reversed);
                this.properties = reversed;
            } else this.updateTarget(0.0) // Manually update target to initial value.
            ;
        }
        this.iterationCount = iteration;
        if (completed) {
            this.completed = true;
            this.stopAnimation();
        }
    }
    stopAnimation() {
        if (!this.animating) return;
        this.animating = false;
        let targetScrollEventHandler = this.targetScrollEventHandler;
        if (targetScrollEventHandler) this.target.removeEventListener(targetScrollEventHandler);
        let request = this.frameRequest;
        if (request) cancelAnimationFrame(request);
        let completion = this.completion;
        if (completion) completion(this.completed);
        this.completion = undefined;
    }
    startAnimation() {
        if (this.animating) return;
        this.animating = true;
        this.iterationCount = 0;
        const targetScrollEventHandler = this.stopAnimation.bind(this);
        // if (this.target.addEventListener) {
        //   for (const name of this.interruptAnimationEvents) {
        //     this.target.addEventListener(name, targetScrollEventHandler)
        //   }
        // }
        const update = this.update.bind(this);
        const animate = ()=>{
            update();
            schedule();
            if (this.animating) {
                const { didAnimate: didAnimate } = this;
                if (didAnimate) didAnimate();
            }
        };
        const schedule = ()=>{
            if (this.animating) this.frameRequest = requestAnimationFrame(animate, this);
        };
        schedule();
    }
}
var $1c98d5f0dd1e30db$export$2e2bcd8739ae039 = $1c98d5f0dd1e30db$var$PropertyAnimator;










var $b8cb10d508970766$exports = {};
$b8cb10d508970766$exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAyAAAAMgCAMAAADsrvZaAAAAAXNSR0IArs4c6QAAAAlwSFlzAAAWJQAAFiUBSVIk8AAAAU1QTFRF%2F%2F%2F%2F%2Fv7%2B%2Ff39%2FPz8%2B%2Fv7%2Bvr6%2Bfn5%2BPj49%2Ff39vb29fX19PT08%2FPz8vLy8fHx8PDw7u7u7e3t7Ozs6%2Bvr6urq6enp6Ojo5%2Bfn5ubm5eXl5OTk4%2BPj4eHh39%2Ff3d3d29vb2dnZ1tbW1dXV1NTU09PT0tLS0dHR0NDQz8%2FPzs7OwcHBwMDAtbW1s7OzsbGxrq6unp6el5eXlZWVi4uLiYmJiIiIh4eHhoaGhYWFhISEg4ODgoKCgYGBgICAf39%2Ffn5%2BfX19fHx8e3t7eXl5cXFxcHBwWFhYV1dXVlZWVVVVVFRUU1NTUlJSUVFRUFBQT09PTk5OOTk5NDQ0MzMzMjIyMTExMDAwLy8vLi4uLS0tKysrKioqKSkpKCgoJycnJiYmJSUlIiIiICAgHh4eGxsbGBgYFxcXFhYWFRUVFBQUExMTEhISBAQEAgICAAAA7bPcuwAABVpJREFUeNrs3ddPk1Ecx%2BFDafVCTdzzyr333hsXLlBRUcABKOrv%2F7%2FDchLU0p430agJvM9z3fTi2%2FPJSUfStJj0z2nwzyUWJSdXIP%2BbLUAgIBAQCAgEBAICAYHAUtVMS8Cs1xGBaAOBaAOBiANv0vWBG0QeuEH0gRtEHtCtoQ8oa%2BgDyvpNAH6LBQIBgYBAQCAgEBAICAQEAggEBAICAYGAQEAgIBAQCAgEBAIIBAQCAgGBAL%2BnL7MDi1Df31J%2BKn2wVAJxxqGDPqCCPqCCPqCC8w8%2BgoU%2FIw8AAAAAAAAAAAAAAAAAAAAAAAAAYNE7eP1YK1U6cOvkCjtRTyci4unqVOHkt4ih5Zailj5G21BFIadizmFLUUtTMWe4WMjpyI5Yilq6GtnwmtTTmcjerbQUtdQciOxZz0LORja53VAopMs5faCQgcier9UHlAt5saCQ8%2FqAYiEX9AEdhYysSz9cjGxyh3lQSFchl%2FQBXYW8XNfRx5Q%2BoKOQ9antsj6gZyGv2oVc0QcUC7mqDygWMq0PKBeiDygUog%2BoKkQfUHYjIhvdYAtY6FrMe60QKPSRC9loD%2BjRx9fIRhUC3X1M7RlQCJT62JGadyJ7s8kq0NHH9M6UUvOuQqDQR1vzXmRvN1sGfvaxKyWFQO8%2BPu1O85r3IxtTCPro7CNrPYhsbIt90Efb5z3pV63ByMYVgj5yH51aDyMb32oj9LE3pUIhEwqh7n3M7E3dWo8im9hmJ%2BrpeGQz%2B1Ivyx5HNuIfpqinD8U%2BsmVPIjtkKWppOtq%2B7E%2BpupCjlqKWbkbETO6jqpD3qyxFLTWOD97aUv2IEw9u%2ByoEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA6qy%2FaQMoaszaAMoafTaAIn0AAAAAAAAAAAAAAHxntw5OAAhCIAiKf%2FMP18vgQPDjUtUxyAgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA8LyCw2IonfxbWn9ZELAgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAsK3gsBhKJ%2F%2BW1l8WBCwIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAbCs4LIYyhlq6mwWB1QXxNAIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAApxUcFkMZQy3dzYLA6oJ4GgEAAAAAAAAAAAAA4Gu%2F7lIgBKEwgKqNRD%2Fuf3Ozl2aG6HEehCiNcz4JehPlehUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgK4V6FiolEKlTaTf6CBwagdxaQQAOFm0BKBAQIGAAgEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOBSBToWKqVQaRPpNzoInNpBXBoBAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgEfKS4FGLDk05zWVVaSFTENoUBpXRxf3W8cU2pRnu8Pd5uzBAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADAX9EScKF4fOKe7zik30hp%2FxnejUz4AzDCxpiZrTHhAAAAAElFTkSuQmCC";


var $0c30dfa99e1c403a$exports = {};
$0c30dfa99e1c403a$exports = "data:image/svg+xml,%3Csvg%20width%3D%22240%22%20height%3D%22240%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M0%2096c0-45.255%200-67.882%2014.059-81.941C28.118%200%2050.745%200%2096%200h48c45.255%200%2067.882%200%2081.941%2014.059C240%2028.118%20240%2050.745%20240%2096v48c0%2045.255%200%2067.882-14.059%2081.941C211.882%20240%20189.255%20240%20144%20240H96c-45.255%200-67.882%200-81.941-14.059C0%20211.882%200%20189.255%200%20144V96Z%22%20fill%3D%22%23000%22%2F%3E%3C%2Fsvg%3E";




class $0413f8710583387d$var$ResizableImageMode {
    static get stretch() {
        return "stretch";
    }
    static get tile() {
        return "tile";
    }
}
class $0413f8710583387d$var$ResizableImage {
    static get mode() {
        return $0413f8710583387d$var$ResizableImageMode;
    }
    constructor(sourceImage, { scale: scale = 1, insets: insets, mode: mode = $0413f8710583387d$var$ResizableImageMode.stretch } = options){
        this.sourceImage = sourceImage; // Image
        this.sourceImageScale = scale; // Number
        this.insets = insets; // { top, left, bottom, right }
        this.mode = mode; // "stretch" | "tile"
    }
    resizedTo({ width: width, height: height } = size, scale = 1) {
        let { sourceImage: sourceImage, sourceImageScale: sourceImageScale, insets: insets, mode: mode } = this;
        // Prepare destination:
        const scaledWidth = width * scale;
        const scaledHeight = height * scale;
        const img = document.createElement("canvas");
        img.width = scaledWidth;
        img.height = scaledHeight;
        const ctx = img.getContext("2d");
        ctx.scale(scale, scale);
        // Pre-draw source image:
        const sourceImageNaturalSize = {
            width: sourceImage.width / sourceImageScale,
            height: sourceImage.height / sourceImageScale
        };
        const rasterizationScale = window.devicePixelRatio; // TODO: Maybe allow this to be customized
        // Replace source image:
        sourceImage = $0413f8710583387d$var$offscreenRasterizedImage(sourceImage, sourceImageNaturalSize.width, sourceImageNaturalSize.height, rasterizationScale);
        sourceImageScale = rasterizationScale;
        // Source/destination scaled dimensions:
        const sSize = {
            width: sourceImage.width,
            height: sourceImage.height
        };
        const sInsets = {
            top: insets.top * sourceImageScale,
            left: insets.left * sourceImageScale,
            bottom: insets.bottom * sourceImageScale,
            right: insets.right * sourceImageScale
        };
        const sTopRightX = sSize.width - sInsets.right;
        const sBottomY = sSize.height - sInsets.bottom;
        const topRightX = width - insets.right;
        const bottomY = height - insets.bottom;
        const sEdgeWidth = sSize.width - sInsets.left - sInsets.right;
        const sEdgeHeight = sSize.height - sInsets.top - sInsets.bottom;
        const edgeWidth = width - insets.right - insets.left;
        const edgeHeight = height - insets.top - insets.bottom;
        // Edges:
        // Top-left corner
        ctx.drawImage(sourceImage, 0, 0, sInsets.left, sInsets.top, 0, 0, insets.left, insets.top);
        // Top-right corner
        ctx.drawImage(sourceImage, sTopRightX, 0, sInsets.right, sInsets.top, topRightX, 0, insets.right, insets.top);
        // Bottom-left corner
        ctx.drawImage(sourceImage, 0, sBottomY, sInsets.left, sInsets.bottom, 0, bottomY, insets.left, insets.bottom);
        // Bottom-right corner
        ctx.drawImage(sourceImage, sTopRightX, sBottomY, sInsets.right, sInsets.bottom, topRightX, bottomY, insets.right, insets.bottom);
        // Edges:
        const fill = (sx, sy, sw, sh, dx, dy, dw, dh)=>{
            if (mode === $0413f8710583387d$var$ResizableImageMode.stretch) ctx.drawImage(sourceImage, sx, sy, sw, sh, dx, dy, dw, dh);
        };
        // Top:
        fill(sInsets.left, 0, sEdgeWidth, sInsets.top, insets.left, 0, edgeWidth, insets.top);
        // Bottom:
        fill(sInsets.left, sSize.height - sInsets.bottom, sEdgeWidth, sInsets.bottom, insets.left, height - insets.bottom, edgeWidth, insets.bottom);
        // Left:
        fill(0, sInsets.top, sInsets.left, sEdgeHeight, 0, insets.top, insets.left, edgeHeight);
        // Right:
        fill(sSize.width - sInsets.right, sInsets.top, sInsets.right, sEdgeHeight, width - insets.right, insets.top, insets.right, edgeHeight);
        // Center:
        fill(sInsets.left, sInsets.top, sEdgeWidth, sEdgeHeight, insets.left, insets.top, edgeWidth, edgeHeight);
        return img;
    }
}
// This pre-draw step is required for SVGs to be rendered correctly on Firefox.
// I also think it's faster to render each patch portion canvas-to-canvas.
function $0413f8710583387d$var$offscreenRasterizedImage(image, width, height, scale = 1) {
    const scaledWidth = width * scale;
    const scaledHeight = height * scale;
    let canvas;
    if (window.OffscreenCanvas) canvas = new OffscreenCanvas(scaledWidth, scaledHeight);
    else {
        canvas = document.createElement("canvas");
        canvas.width = scaledWidth;
        canvas.height = scaledHeight;
    }
    const ctx = canvas.getContext("2d");
    ctx.scale(scale, scale);
    ctx.drawImage(image, 0, 0, width, height);
    return canvas;
}
var $0413f8710583387d$export$2e2bcd8739ae039 = $0413f8710583387d$var$ResizableImage;


const $39dfe3cd257bed89$var$processImage = (src)=>{
    return new Promise((resolve, reject)=>{
        const img = new Image();
        img.onload = ()=>resolve(img);
        img.onerror = reject;
        img.src = src;
    });
};
var $39dfe3cd257bed89$export$2e2bcd8739ae039 = $39dfe3cd257bed89$var$processImage;




class $ac40bc17cdbaaba0$var$CSSMaskBorderPolyfillRenderer {
    constructor(node, options){
        this.node = node;
        this.options = options;
        this.initialize();
        const resizeListener = this.update.bind(this);
        this.resizeListener = resizeListener;
        window.addEventListener("resize", resizeListener);
    }
    invalidate() {
        const { resizeListener: resizeListener } = this;
        if (resizeListener) window.removeEventListener("resize", resizeListener);
    }
    update() {
        const { node: node, options: options, maskSourceImage: maskSourceImage } = this;
        const { maskBorderSlice: maskBorderSlice } = options;
        // Assumes a single integer number, obviously wrong:
        // https://developer.mozilla.org/en-US/docs/Web/CSS/mask-border-slice
        const sliceValues = {
            width: parseInt(maskBorderSlice),
            height: parseInt(maskBorderSlice)
        };
        const padding = {
            top: sliceValues.height,
            right: sliceValues.width,
            bottom: sliceValues.height,
            left: sliceValues.width
        };
        const rect = node.getBoundingClientRect();
        if (rect.width <= 0 || rect.height <= 0) return;
        if (rect.width == this.latestWidth && rect.height == this.latestHeight) return;
        this.latestWidth = rect.width;
        this.latestHeight = rect.height;
        const scale = window.devicePixelRatio || 1;
        const scaledWidth = rect.width * scale;
        const scaledHeight = rect.height * scale;
        let canvas = this.canvas;
        if (!canvas) {
            canvas = document.createElement("canvas");
            this.canvas = canvas;
            this.ctx = canvas.getContext("2d");
        }
        canvas.width = scaledWidth;
        canvas.height = scaledHeight;
        const ctx = this.ctx;
        ctx.scale(scale, scale);
        const resizableImage = new (0, $0413f8710583387d$export$2e2bcd8739ae039)(maskSourceImage, {
            insets: padding
        });
        const resizedImage = resizableImage.resizedTo({
            width: rect.width,
            height: rect.height
        }, scale);
        ctx.drawImage(resizedImage, 0, 0, rect.width, rect.height);
        const img = canvas.toDataURL("image/png");
        const { style: style } = this.node;
        style.maskImage = `url(${img})`;
        style.maskSize = `${rect.width}px ${rect.height}px`;
        style.maskRepeat = "no-repeat";
    }
    async initialize() {
        const { maskBorderSource: maskBorderSource } = this.options;
        function extractURL(declaration) {
            const regex = /url\(['"]?(.*?)['"]?\)/;
            const match = declaration.match(regex);
            return match ? match[1] : null;
        }
        let { maskSourceImage: maskSourceImage } = this;
        if (!maskSourceImage) {
            const sourceURL = extractURL(maskBorderSource);
            maskSourceImage = await (0, $39dfe3cd257bed89$export$2e2bcd8739ae039)(sourceURL);
            this.maskSourceImage = maskSourceImage;
        }
        window.requestAnimationFrame(()=>{
            this.update();
        });
    }
}
var $ac40bc17cdbaaba0$export$2e2bcd8739ae039 = {
    Renderer: $ac40bc17cdbaaba0$var$CSSMaskBorderPolyfillRenderer
};






class $e4edac4ad8982533$var$RectEdge {
    static top = 0;
    static left = 1;
    static bottom = 2;
    static right = 3;
    static description(fromEdge) {
        const { top: top, left: left, bottom: bottom, right: right } = this;
        const map = {
            [top]: "top",
            [left]: "left",
            [bottom]: "bottom",
            [right]: "right"
        };
        return map[fromEdge] || "unknown";
    }
}
var $e4edac4ad8982533$export$2e2bcd8739ae039 = $e4edac4ad8982533$var$RectEdge;


const $fac61b2ebda88f38$var$curvesAnimationStart = 0.0;
const $fac61b2ebda88f38$var$curvesAnimationEnd = 0.4;
const $fac61b2ebda88f38$var$slideAnimationStart = 0.3;
const $fac61b2ebda88f38$var$slideAnimationEnd = 1.0;
const $fac61b2ebda88f38$var$kSliceSize = 2.0;
const $fac61b2ebda88f38$var$kFPS = 60.0;
const $fac61b2ebda88f38$var$kRenderMargin = 0.0;
function $fac61b2ebda88f38$var$isEdgeVertical(edge) {
    return edge == (0, $e4edac4ad8982533$export$2e2bcd8739ae039).top || edge == (0, $e4edac4ad8982533$export$2e2bcd8739ae039).bottom;
}
function $fac61b2ebda88f38$var$isEdgeNegative(d) {
    return d & 2;
}
function $fac61b2ebda88f38$var$axisForEdge(edge) {
    return $fac61b2ebda88f38$var$isEdgeVertical(edge) ? $fac61b2ebda88f38$var$Axis.y : $fac61b2ebda88f38$var$Axis.x;
}
function $fac61b2ebda88f38$var$perpAxis(axis) {
    return axis == $fac61b2ebda88f38$var$Axis.x ? $fac61b2ebda88f38$var$Axis.y : $fac61b2ebda88f38$var$Axis.x;
}
class $fac61b2ebda88f38$var$Axis {
    static x = "x";
    static y = "y";
}
class $fac61b2ebda88f38$var$Trapezoid {
    constructor(a, b, c, d){
        this.a = (0, $ba5a447b6ce1696c$exports.Point).from(a);
        this.b = (0, $ba5a447b6ce1696c$exports.Point).from(b);
        this.c = (0, $ba5a447b6ce1696c$exports.Point).from(c);
        this.d = (0, $ba5a447b6ce1696c$exports.Point).from(d);
    }
    copy() {
        return new $fac61b2ebda88f38$var$Trapezoid(this.a, this.b, this.c, this.d);
    }
    static get winding() {
        const { top: top, left: left, bottom: bottom, right: right } = (0, $e4edac4ad8982533$export$2e2bcd8739ae039);
        const a = "a", b = "b", c = "c", d = "d";
        const winding = new Array();
        winding[top] = [
            a,
            b,
            c,
            d
        ];
        winding[left] = [
            c,
            a,
            d,
            b
        ];
        winding[bottom] = [
            d,
            c,
            b,
            a
        ];
        winding[right] = [
            b,
            d,
            a,
            c
        ];
        return winding;
    }
}
class $fac61b2ebda88f38$var$Segment {
    constructor(a, b){
        this.a = (0, $ba5a447b6ce1696c$exports.Point).from(a);
        this.b = (0, $ba5a447b6ce1696c$exports.Point).from(b);
    }
    static make(a, b) {
        return new $fac61b2ebda88f38$var$Segment(a, b);
    }
    copy() {
        return new $fac61b2ebda88f38$var$Segment(this.a, this.b);
    }
}
class $fac61b2ebda88f38$var$Slice {
    frame;
}
class $fac61b2ebda88f38$var$GenieAnimation {
    constructor({ originRect: originRect, destinationRect: destinationRect, destinationEdge: destinationEdge, reverse: reverse, duration: duration }){
        this.frameCount = $fac61b2ebda88f38$var$kFPS * (duration / 1000);
        this.options = {
            originRect: (0, $ba5a447b6ce1696c$exports.Rect).from(originRect),
            destinationRect: (0, $ba5a447b6ce1696c$exports.Rect).from(destinationRect),
            destinationEdge: destinationEdge,
            reverse: reverse,
            duration: duration
        };
    }
    slice(bounds, axis) {
        const totalSize = axis == $fac61b2ebda88f38$var$Axis.y ? bounds.height : bounds.width;
        const origin = (0, $ba5a447b6ce1696c$exports.Point).zero;
        origin[axis] = $fac61b2ebda88f38$var$kSliceSize;
        const sliceSize = axis == $fac61b2ebda88f38$var$Axis.y ? (0, $ba5a447b6ce1696c$exports.Size).make(bounds.width, $fac61b2ebda88f38$var$kSliceSize) : (0, $ba5a447b6ce1696c$exports.Size).make($fac61b2ebda88f38$var$kSliceSize, bounds.height);
        const count = Math.ceil(totalSize / $fac61b2ebda88f38$var$kSliceSize);
        const slices = new Array();
        for(let i = 0; i < count; i++){
            const rect = (0, $ba5a447b6ce1696c$exports.Rect).make(i * origin.x, i * origin.y, sliceSize.width, sliceSize.height);
            const slice = new $fac61b2ebda88f38$var$Slice();
            slice.frame = rect;
            slices.push(slice);
        }
        return slices;
    }
    calculate() {
        const { options: options } = this;
        const { duration: duration, originRect: originRect, destinationRect: destinationRect, destinationEdge: destinationEdge, reverse: reverse } = options;
        const axis = $fac61b2ebda88f38$var$axisForEdge(destinationEdge);
        const pAxis = $fac61b2ebda88f38$var$perpAxis(axis);
        const xInset = axis == $fac61b2ebda88f38$var$Axis.y ? -$fac61b2ebda88f38$var$kRenderMargin : 0.0;
        const yInset = axis == $fac61b2ebda88f38$var$Axis.x ? -$fac61b2ebda88f38$var$kRenderMargin : 0.0;
        const marginedDestRect = destinationRect.insetBy(xInset * destinationRect.width / originRect.width, yInset * destinationRect.height / originRect.height);
        const endRectDepth = $fac61b2ebda88f38$var$isEdgeVertical(destinationEdge) ? marginedDestRect.height : marginedDestRect.width;
        const aPoints = $fac61b2ebda88f38$var$bezierEndPointsForTransition(destinationEdge, originRect.offsetBy(xInset, yInset));
        const bEndPoints = $fac61b2ebda88f38$var$bezierEndPointsForTransition(destinationEdge, marginedDestRect);
        const bStartPoints = aPoints.copy();
        bStartPoints.a[axis] = bEndPoints.a[axis];
        bStartPoints.b[axis] = bEndPoints.b[axis];
        const first = new $fac61b2ebda88f38$var$Segment(aPoints.a, bStartPoints.a);
        const second = new $fac61b2ebda88f38$var$Segment(aPoints.b, bStartPoints.b);
        // Slice:
        const slices = this.slice(originRect, axis);
        // TODO: get the actual height or width of every slice summed:
        let totalSize = 0.0;
        slices.forEach((slice)=>{
            const { frame: frame } = slice;
            totalSize += $fac61b2ebda88f38$var$isEdgeVertical(destinationEdge) ? frame.height : frame.width;
        });
        const sign = $fac61b2ebda88f38$var$isEdgeNegative(destinationEdge) ? -1 : 1.0;
        if (sign * (aPoints.a[axis] - bEndPoints.a[axis]) > 0.0) {
            console.warn(`Genie Effect ERROR: The distance between ${(0, $e4edac4ad8982533$export$2e2bcd8739ae039).description(destinationEdge)} edge of animated view and ${(0, $e4edac4ad8982533$export$2e2bcd8739ae039).description(destinationEdge)} edge of ${reverse ? "start" : "destination"} rect is incorrect. Animation will not be performed!`);
            return;
        } else if (sign * (aPoints.a[axis] + sign * totalSize - bEndPoints.a[axis]) > 0.0) console.warn(`Genie Effect Warning: The ${(0, $e4edac4ad8982533$export$2e2bcd8739ae039).description(destinationEdge)} edge of animated view overlaps ${(0, $e4edac4ad8982533$export$2e2bcd8739ae039).description((destinationEdge + 2) % 4)} edge of ${reverse ? "start" : "destination"} rect. Glitches may occur.`);
        // Prepare storage for transforms:
        const transforms = new Array();
        slices.forEach((slice, index)=>{
            transforms.push(new Array());
        });
        const totalIter = duration / 1000 * $fac61b2ebda88f38$var$kFPS;
        const tSignShift = reverse ? -1 : 1.0;
        for(let i = 0; i < totalIter; i++){
            const progress = i / (totalIter - 1.0);
            const t = tSignShift * (progress - 0.5) + 0.5;
            const curveP = $fac61b2ebda88f38$var$progressOfSegmentWithinTotalProgress($fac61b2ebda88f38$var$curvesAnimationStart, $fac61b2ebda88f38$var$curvesAnimationEnd, t);
            first.b[pAxis] = $fac61b2ebda88f38$var$easeInOutInterpolate(curveP, bStartPoints.a[pAxis], bEndPoints.a[pAxis]);
            second.b[pAxis] = $fac61b2ebda88f38$var$easeInOutInterpolate(curveP, bStartPoints.b[pAxis], bEndPoints.b[pAxis]);
            const slideP = $fac61b2ebda88f38$var$progressOfSegmentWithinTotalProgress($fac61b2ebda88f38$var$slideAnimationStart, $fac61b2ebda88f38$var$slideAnimationEnd, t);
            const trs = this.calculateTransformationsFor(slices, destinationEdge, $fac61b2ebda88f38$var$easeInOutInterpolate(slideP, first.a[axis], first.b[axis]), totalSize, first, second, endRectDepth);
            trs.forEach((transform, sliceIndex)=>{
                transforms[sliceIndex].push(transform);
            });
        }
        return {
            slices: slices,
            transforms: transforms
        };
    }
    calculateTransformationsFor(slices, edge, startPosition, totalSize, firstBezier, secondBezier, finalRectDepth) {
        const first = firstBezier, second = secondBezier;
        const transformations = new Array();
        const axis = $fac61b2ebda88f38$var$axisForEdge(edge);
        const rectPartStart = first.b[axis];
        const sign = $fac61b2ebda88f38$var$isEdgeNegative(edge) ? -1 : 1.0;
        (0, $27637818bf42bbb8$exports.assert)(sign * (startPosition - rectPartStart) <= 0.0, "WTF");
        let position = startPosition;
        let trapezoid = new $fac61b2ebda88f38$var$Trapezoid((0, $ba5a447b6ce1696c$exports.Point).zero, (0, $ba5a447b6ce1696c$exports.Point).zero, (0, $ba5a447b6ce1696c$exports.Point).zero, (0, $ba5a447b6ce1696c$exports.Point).zero);
        trapezoid[$fac61b2ebda88f38$var$Trapezoid.winding[edge][0]] = $fac61b2ebda88f38$var$bezierAxisIntersection(first, axis, position);
        trapezoid[$fac61b2ebda88f38$var$Trapezoid.winding[edge][1]] = $fac61b2ebda88f38$var$bezierAxisIntersection(second, axis, position);
        const enumeration = $fac61b2ebda88f38$var$isEdgeNegative(edge) ? slices.slice().reverse() : slices;
        enumeration.forEach((slice, idx)=>{
            const size = $fac61b2ebda88f38$var$isEdgeVertical(edge) ? slice.frame.height : slice.frame.width;
            const endPosition = position + sign * size; // we're not interested in slices' origins since they will be moved around anyway
            const overflow = sign * (endPosition - rectPartStart);
            if (overflow <= 0.0) {
                trapezoid[$fac61b2ebda88f38$var$Trapezoid.winding[edge][2]] = $fac61b2ebda88f38$var$bezierAxisIntersection(first, axis, endPosition);
                trapezoid[$fac61b2ebda88f38$var$Trapezoid.winding[edge][3]] = $fac61b2ebda88f38$var$bezierAxisIntersection(second, axis, endPosition);
            } else {
                let shrunkSliceDepth = overflow * finalRectDepth / totalSize; // how deep inside final rect "bottom" part of slice is
                trapezoid[$fac61b2ebda88f38$var$Trapezoid.winding[edge][2]] = first.b.copy();
                trapezoid[$fac61b2ebda88f38$var$Trapezoid.winding[edge][2]][axis] += sign * shrunkSliceDepth;
                trapezoid[$fac61b2ebda88f38$var$Trapezoid.winding[edge][3]] = second.b.copy();
                trapezoid[$fac61b2ebda88f38$var$Trapezoid.winding[edge][3]][axis] += sign * shrunkSliceDepth;
            }
            const transform = this.transformRectToTrapezoid(slice.frame, trapezoid);
            transformations.push(transform);
            trapezoid[$fac61b2ebda88f38$var$Trapezoid.winding[edge][0]] = trapezoid[$fac61b2ebda88f38$var$Trapezoid.winding[edge][2]]; // next one starts where previous one ends
            trapezoid[$fac61b2ebda88f38$var$Trapezoid.winding[edge][1]] = trapezoid[$fac61b2ebda88f38$var$Trapezoid.winding[edge][3]];
            position = endPosition;
        });
        if ($fac61b2ebda88f38$var$isEdgeNegative(edge)) transformations.reverse();
        return transformations;
    }
    transformRectToTrapezoid(rect, trapezoid) {
        const W = rect.size.width;
        const H = rect.size.height;
        const x1a = trapezoid.a.x;
        const y1a = trapezoid.a.y;
        const x2a = trapezoid.b.x;
        const y2a = trapezoid.b.y;
        const x3a = trapezoid.c.x;
        const y3a = trapezoid.c.y;
        const x4a = trapezoid.d.x;
        const y4a = trapezoid.d.y;
        const y21 = y2a - y1a, y32 = y3a - y2a, y43 = y4a - y3a, y14 = y1a - y4a, y31 = y3a - y1a, y42 = y4a - y2a;
        const a = -H * (x2a * x3a * y14 + x2a * x4a * y31 - x1a * x4a * y32 + x1a * x3a * y42);
        const b = W * (x2a * x3a * y14 + x3a * x4a * y21 + x1a * x4a * y32 + x1a * x2a * y43);
        const c = -H * W * x1a * (x4a * y32 - x3a * y42 + x2a * y43);
        const d = H * (-x4a * y21 * y3a + x2a * y1a * y43 - x1a * y2a * y43 - x3a * y1a * y4a + x3a * y2a * y4a);
        const e = W * (x4a * y2a * y31 - x3a * y1a * y42 - x2a * y31 * y4a + x1a * y3a * y42);
        const f = -(W * (x4a * (H * y1a * y32) - x3a * H * y1a * y42 + H * x2a * y1a * y43));
        const g = H * (x3a * y21 - x4a * y21 + (-x1a + x2a) * y43);
        const h = W * (-x2a * y31 + x4a * y31 + (x1a - x3a) * y42);
        let i = H * (W * (-(x3a * y2a) + x4a * y2a + x2a * y3a - x4a * y3a - x2a * y4a + x3a * y4a));
        const kEpsilon = 0.0001;
        if (Math.abs(i) < kEpsilon) i = kEpsilon * (i > 0 ? 1.0 : -1);
        const init = [
            a / i,
            d / i,
            0,
            g / i,
            b / i,
            e / i,
            0,
            h / i,
            0,
            0,
            1,
            0,
            c / i,
            f / i,
            0,
            1.0
        ];
        const transform = new DOMMatrix(init);
        return transform;
    }
}
function $fac61b2ebda88f38$var$bezierEndPointsForTransition(edge, endRect) {
    switch(edge){
        case (0, $e4edac4ad8982533$export$2e2bcd8739ae039).top:
            return $fac61b2ebda88f38$var$Segment.make((0, $ba5a447b6ce1696c$exports.Point).make(endRect.minX, endRect.minY), (0, $ba5a447b6ce1696c$exports.Point).make(endRect.maxX, endRect.minY));
        case (0, $e4edac4ad8982533$export$2e2bcd8739ae039).bottom:
            return $fac61b2ebda88f38$var$Segment.make((0, $ba5a447b6ce1696c$exports.Point).make(endRect.maxX, endRect.maxY), (0, $ba5a447b6ce1696c$exports.Point).make(endRect.minX, endRect.maxY));
        case (0, $e4edac4ad8982533$export$2e2bcd8739ae039).right:
            return $fac61b2ebda88f38$var$Segment.make((0, $ba5a447b6ce1696c$exports.Point).make(endRect.maxX, endRect.minY), (0, $ba5a447b6ce1696c$exports.Point).make(endRect.maxX, endRect.maxY));
        case (0, $e4edac4ad8982533$export$2e2bcd8739ae039).left:
            return $fac61b2ebda88f38$var$Segment.make((0, $ba5a447b6ce1696c$exports.Point).make(endRect.minX, endRect.maxY), (0, $ba5a447b6ce1696c$exports.Point).make(endRect.minX, endRect.minY));
    }
    throw new Error("State error");
}
function $fac61b2ebda88f38$var$progressOfSegmentWithinTotalProgress(a, b, t) {
    (0, $27637818bf42bbb8$exports.assert)(b > a);
    return Math.min(Math.max(0.0, (t - a) / (b - a)), 1.0);
}
function $fac61b2ebda88f38$var$easeInOutInterpolate(t, a, b) {
    (0, $27637818bf42bbb8$exports.assert)(t >= 0.0 && t <= 1.0); // we don't want any other values
    const val = a + t * t * (3.0 - 2.0 * t) * (b - a);
    return b > a ? Math.max(a, Math.min(val, b)) : Math.max(b, Math.min(val, a)); // clamping, since numeric precision might bite here
}
function $fac61b2ebda88f38$var$bezierAxisIntersection(curve, axis, axisPos) {
    (0, $27637818bf42bbb8$exports.assert)(axisPos >= curve.a[axis] && axisPos <= curve.b[axis] || axisPos >= curve.b[axis] && axisPos <= curve.a[axis]);
    const pAxis = $fac61b2ebda88f38$var$perpAxis(axis);
    const c1 = (0, $ba5a447b6ce1696c$exports.Point).zero, c2 = (0, $ba5a447b6ce1696c$exports.Point).zero;
    c1[pAxis] = curve.a[pAxis];
    c1[axis] = (curve.a[axis] + curve.b[axis]) / 2.0;
    c2[pAxis] = curve.b[pAxis];
    c2[axis] = (curve.a[axis] + curve.b[axis]) / 2.0;
    let t = (axisPos - curve.a[axis]) / (curve.b[axis] - curve.a[axis]); // first approximation - treating curve as linear segment
    const kIterations = 3; // Newton-Raphson iterations
    for(let i = 0; i < kIterations; i++){
        const nt = 1.0 - t;
        const f = nt * nt * nt * curve.a[axis] + 3.0 * nt * nt * t * c1[axis] + 3.0 * nt * t * t * c2[axis] + t * t * t * curve.b[axis] - axisPos;
        const df = -3 * (curve.a[axis] * nt * nt + c1[axis] * (-3 * t * t + 4.0 * t - 1.0) + t * (3.0 * c2[axis] * t - 2.0 * c2[axis] - curve.b[axis] * t));
        t -= f / df;
    }
    (0, $27637818bf42bbb8$exports.assert)(t >= 0 && t <= 1.0);
    const nt = 1.0 - t;
    const intersection = nt * nt * nt * curve.a[pAxis] + 3.0 * nt * nt * t * c1[pAxis] + 3.0 * nt * t * t * c2[pAxis] + t * t * t * curve.b[pAxis];
    const ret = (0, $ba5a447b6ce1696c$exports.Point).zero;
    ret[axis] = axisPos;
    ret[pAxis] = intersection;
    return ret;
}
var $fac61b2ebda88f38$export$2e2bcd8739ae039 = $fac61b2ebda88f38$var$GenieAnimation;




// If not falls back on `PropertyAnimator`
const $d872a62e6a7633bb$var$supportsBrowserAnimations = !!Element.prototype.animate;
// For some reason, syncing up animations on WebKit looks janky.
const $d872a62e6a7633bb$var$setStartTimeRequired = navigator.userAgent.includes("Firefox");
class $d872a62e6a7633bb$var$GenieTransitionAnimator {
    didComplete;
    supportsBrowserAnimations;
    constructor(animation, image, scale){
        (0, $27637818bf42bbb8$exports.assert)(animation, "An animation is required.");
        (0, $27637818bf42bbb8$exports.assert)(image, "A source image is required.");
        this.genieAnimation = animation;
        this.image = image;
        this.scale = scale;
        this.data = animation.calculate();
        this.frame = 0;
        this._createElement();
        this._applyFrame();
    }
    animate() {
        if (!this.data) // TODO: Animation is not possible.
        return;
        const { genieAnimation: genieAnimation } = this;
        const { duration: duration } = genieAnimation.options;
        const completion = ()=>{
            const { didComplete: didComplete } = this;
            if (didComplete) didComplete();
        };
        if ($d872a62e6a7633bb$var$supportsBrowserAnimations) {
            const options = {
                easing: "linear",
                duration: duration,
                fill: "forwards"
            };
            const { frame: frame, data: data, sliceElements: sliceElements } = this;
            const { slices: slices, transforms: transforms } = data;
            const startTime = $d872a62e6a7633bb$var$setStartTimeRequired ? document.timeline.currentTime : undefined;
            const animations = slices.map((slice, idx)=>{
                const transformsForSlice = transforms[idx];
                const element = sliceElements[idx];
                const animation = element.animate({
                    transform: transformsForSlice
                }, options);
                if ($d872a62e6a7633bb$var$setStartTimeRequired) animation.startTime = startTime;
                return animation;
            });
            animations[0].finished.then(completion);
        } else {
            const options = {
                timingCurve: (0, $78e7515453ca2290$exports).linear
            };
            const animator = new (0, $1c98d5f0dd1e30db$export$2e2bcd8739ae039)(options);
            animator.didAnimate = ()=>{
                this._applyFrame();
            };
            animator.animate(this, {
                frame: genieAnimation.frameCount
            }, duration, completion);
        }
    }
    _createElement() {
        const { image: image, scale: scale, data: data } = this;
        const { slices: slices } = data;
        const fragment = new DocumentFragment();
        const overdrawHeight = 1;
        const sliceElements = [];
        const containerSize = {
            width: 0.0,
            height: 0.0
        };
        slices.forEach((slice, idx)=>{
            const { frame: frame } = slice;
            const overdraw = idx == 0 ? 0 : overdrawHeight;
            const element = document.createElement("canvas");
            element.width = frame.width * scale;
            element.height = (frame.height + overdraw * 2) * scale;
            element.style.width = `${frame.width}px`;
            element.style.height = `${frame.height + overdraw * 2}px`;
            element.style.position = "absolute";
            element.style.left = "0px";
            element.style.top = `-${overdraw}px`;
            element.style.imageRendering = "pixelated";
            element.style.zIndex = slices.length - idx;
            element.style.transformOrigin = "0px 0px";
            element.style.willAnimate = "transform";
            const ctx = element.getContext("2d");
            ctx.scale(scale, scale);
            ctx.drawImage(image, frame.x * scale, (frame.y - overdraw) * scale, frame.width * scale, (frame.height + overdraw * 2) * scale, 0, 0, frame.width, frame.height + overdraw * 2);
            fragment.appendChild(element);
            sliceElements.push(element);
            containerSize.width = frame.width;
            containerSize.height += frame.height;
        });
        const container = document.createElement("div");
        container.className = "genie-transition-animator-container";
        container.style.position = "absolute";
        container.style.width = `${containerSize.width}px`;
        container.style.height = `${containerSize.height}px`;
        container.style.transform = "translate3d(0, 0, 0)";
        container.appendChild(fragment);
        this._element = container;
        this.sliceElements = sliceElements;
    }
    _applyFrame() {
        const { frame: frame, data: data, sliceElements: sliceElements } = this;
        const { slices: slices, transforms: transforms } = data;
        const currentFrame = Math.floor(frame);
        slices.forEach((slice, idx)=>{
            const transformsForSlice = transforms[idx];
            const element = sliceElements[idx];
            element.style.transform = transformsForSlice[currentFrame];
        });
    }
    get element() {
        return this._element;
    }
}
var $d872a62e6a7633bb$export$2e2bcd8739ae039 = $d872a62e6a7633bb$var$GenieTransitionAnimator;





class $76a9e1a621d3da16$var$SheetTransitionPhase {
    static willBegin = 0;
    static didEnd = 1;
}
class $76a9e1a621d3da16$var$SheetTransitionStyle {
    static default = 0;
    static destroy = 1;
}
class $76a9e1a621d3da16$var$SheetTransitionCoordinator {
    delegate;
    static get TransitionStyle() {
        return $76a9e1a621d3da16$var$SheetTransitionStyle;
    }
    constructor({ containerNode: containerNode, sourceNode: sourceNode, sheetNode: sheetNode, completion: completion } = options){
        this.options = {
            containerNode: containerNode,
            sourceNode: sourceNode,
            sheetNode: sheetNode,
            completion: completion
        };
    }
    show() {
        if (this.isTransitioning) {
            console.warn("`show()` called while already in a transition.");
            return;
        }
        this.isTransitioning = true;
        const present = async ()=>{
            await this.addSheetMask();
            await this.snapshotter.prepare();
            await this.createSourceImage();
            this.animate(true);
        };
        window.requestAnimationFrame(present);
    }
    dismiss(transitionStyle) {
        if (this.isTransitioning) {
            console.warn("`dismiss()` called while already in a transition.");
            return;
        }
        this.isTransitioning = true;
        const dismiss = async ()=>{
            this.maskBorderRenderer?.invalidate();
            if (transitionStyle == $76a9e1a621d3da16$var$SheetTransitionStyle.destroy) {
                this.animateDestroy();
                return;
            }
            await this.snapshotter.prepare();
            await this.createSourceImage();
            this.animate(false);
        };
        window.requestAnimationFrame(dismiss);
    }
    // -
    async addSheetMask() {
        const { sheetNode: sheetNode } = this.options;
        // Apply border mask:
        const maskBorderSource = `url(${(0, (/*@__PURE__*/$parcel$interopDefault($0c30dfa99e1c403a$exports)))})`;
        const maskBorderSlice = "92 fill";
        if (CSS.supports("mask-border-source", maskBorderSource)) {
            sheetNode.style.maskBorderSource = maskBorderSource;
            sheetNode.style.maskBorderSlice = maskBorderSlice;
        } else this.maskBorderRenderer = new (0, $ac40bc17cdbaaba0$export$2e2bcd8739ae039).Renderer(sheetNode, {
            maskBorderSource: maskBorderSource,
            maskBorderSlice: maskBorderSlice
        });
    }
    async createSourceImage() {
        const { containerNode: containerNode, sheetNode: sheetNode } = this.options;
        const sheetNodeRect = sheetNode.getBoundingClientRect();
        const sheet = await (0, $39dfe3cd257bed89$export$2e2bcd8739ae039)((0, (/*@__PURE__*/$parcel$interopDefault($0c30dfa99e1c403a$exports))));
        const createCanvas = (width, height, scale)=>{
            const canvas = document.createElement("canvas");
            canvas.width = width * scale;
            canvas.height = height * scale;
            canvas.style.position = "absolute";
            canvas.style.width = `${width}px`;
            canvas.style.height = `${height}px`;
            const ctx = canvas.getContext("2d");
            ctx.scale(scale, scale);
            return {
                canvas: canvas,
                ctx: ctx
            };
        };
        const scale = window.devicePixelRatio || 1;
        const bounds = sheetNodeRect;
        const { canvas: canvas, ctx: ctx } = createCanvas(bounds.width, bounds.height, scale);
        const sheetCorner = {
            width: Math.floor(sheet.width / 2) - 1,
            height: Math.floor(sheet.height / 2) - 1
        };
        const padding = {
            top: sheetCorner.height,
            right: sheetCorner.width,
            bottom: sheetCorner.height,
            left: sheetCorner.width
        };
        // Draw clipping shape:
        const { canvas: maskingCanvas } = createCanvas(bounds.width, bounds.height, scale);
        const resizableSheet = new (0, $0413f8710583387d$export$2e2bcd8739ae039)(sheet, {
            insets: padding
        });
        const resizedSheet = resizableSheet.resizedTo({
            width: bounds.width,
            height: bounds.height
        }, scale);
        maskingCanvas.getContext("2d").drawImage(resizedSheet, 0, 0, bounds.width, bounds.height);
        // Draw content:
        ctx.save();
        this.snapshotter.drawSnapshotInContext(ctx, sheetNode, sheetNodeRect);
        ctx.restore();
        ctx.globalCompositeOperation = "destination-in"; // Use destination as a mask
        ctx.fillStyle = "black";
        ctx.drawImage(maskingCanvas, 0, 0, bounds.width, bounds.height);
        // Save:
        this.transitionCanvas = canvas;
        this.transitionCanvasScale = scale;
    }
    animate(direction) {
        const { transitionCanvas: transitionCanvas } = this;
        const { sheetNode: sheetNode, sourceNode: sourceNode, containerNode: containerNode } = this.options;
        const sheetNodeRect = sheetNode.getBoundingClientRect();
        const sourceNodeRect = sourceNode.getBoundingClientRect();
        let destinationRect;
        destinationRect = (0, $ba5a447b6ce1696c$exports.Rect).make(sourceNodeRect.x, sourceNodeRect.y, sourceNodeRect.width, sourceNodeRect.height);
        destinationRect.origin.y = sourceNodeRect.y + sourceNodeRect.height;
        destinationRect = destinationRect.insetBy(24, 0);
        containerNode.style.height = `${sourceNodeRect.y + sourceNodeRect.height}px`;
        containerNode.style.overflow = "hidden";
        const options1 = {
            originRect: (0, $ba5a447b6ce1696c$exports.Rect).make(sheetNodeRect.x, sheetNodeRect.y, sheetNodeRect.width, sheetNodeRect.height),
            destinationRect: destinationRect,
            destinationEdge: (0, $e4edac4ad8982533$export$2e2bcd8739ae039).top,
            duration: 800,
            reverse: direction
        };
        const animation = new (0, $fac61b2ebda88f38$export$2e2bcd8739ae039)(options1);
        const animator = new (0, $d872a62e6a7633bb$export$2e2bcd8739ae039)(animation, transitionCanvas, this.transitionCanvasScale);
        animator.didComplete = ()=>{
            this.notifyDelegatePhase($76a9e1a621d3da16$var$SheetTransitionPhase.didEnd, direction);
            animator.element.remove();
        };
        this.animator = animator;
        containerNode.appendChild(animator.element);
        this.notifyDelegatePhase($76a9e1a621d3da16$var$SheetTransitionPhase.willBegin, direction);
        sheetNode.style.visibility = "hidden";
        animator.animate();
    }
    notifyDelegatePhase(phase, direction) {
        if (phase == $76a9e1a621d3da16$var$SheetTransitionPhase.didEnd) this.isTransitioning = false;
        const { delegate: delegate } = this;
        if (!delegate) return;
        const { willBegin: willBegin, didEnd: didEnd } = $76a9e1a621d3da16$var$SheetTransitionPhase;
        let fn;
        switch(phase){
            case willBegin:
                fn = delegate.sheetTransitionCoordinatorWillBegin;
                break;
            case didEnd:
                fn = delegate.sheetTransitionCoordinatorDidComplete;
                break;
        }
        if (fn) fn.bind(delegate)(this, direction);
    }
    // - Destroy
    animateDestroy() {
        this.notifyDelegatePhase($76a9e1a621d3da16$var$SheetTransitionPhase.willBegin, false);
        const { containerNode: containerNode, sheetNode: sheetNode } = this.options;
        const containerNodeRect = containerNode.getBoundingClientRect();
        const sheetNodeRect = sheetNode.getBoundingClientRect();
        const keyframes = [
            {
                transform: new DOMMatrix()
            },
            {
                transform: new DOMMatrix().translate(0, sheetNodeRect.height + containerNodeRect.height - sheetNodeRect.y).rotate(25)
            }
        ];
        let contentContainerNode, node = sheetNode;
        do if (node?.classList.contains("sheet-container")) {
            contentContainerNode = node;
            break;
        }
        while (node && (node = node.parentNode));
        const animation = contentContainerNode.animate(keyframes, {
            duration: 900,
            fill: "forwards",
            easing: "ease-in"
        });
        animation.finished.then(()=>{
            this.notifyDelegatePhase($76a9e1a621d3da16$var$SheetTransitionPhase.didEnd, false);
        });
    }
}
var $76a9e1a621d3da16$export$2e2bcd8739ae039 = $76a9e1a621d3da16$var$SheetTransitionCoordinator;





class $058cbf30945e9626$var$ContactPresentationSnapshotter {
    static get contact() {
        return new this({
            backgroundImageSrc: (0, (/*@__PURE__*/$parcel$interopDefault($b8cb10d508970766$exports)))
        });
    }
    static get sent() {
        return new this();
    }
    constructor(options){
        const { backgroundImageSrc: backgroundImageSrc } = options ?? {};
        this.backgroundImageSrc = backgroundImageSrc;
    }
    async prepare() {
        if (this.backgroundImage) return;
        const { backgroundImageSrc: backgroundImageSrc } = this;
        if (backgroundImageSrc) this.backgroundImage = await (0, $39dfe3cd257bed89$export$2e2bcd8739ae039)(backgroundImageSrc);
    }
    drawSnapshotInContext(ctx, node, nodeRect) {
        const { draw: draw, backgroundImage: backgroundImage } = this;
        if (backgroundImage) {
            const resizable = new (0, $0413f8710583387d$export$2e2bcd8739ae039)(backgroundImage, {
                scale: 2,
                insets: {
                    top: 135,
                    left: 64,
                    bottom: 44,
                    right: 32
                }
            });
            const resized = resizable.resizedTo({
                width: nodeRect.width,
                height: nodeRect.height
            }, window.devicePixelRatio);
            ctx.drawImage(resized, 0, 0, nodeRect.width, nodeRect.height);
        }
        // Draw backdrop:
        const backdrop = node.querySelector(".backdrop");
        if (backdrop) {
            const backdropStyle = window.getComputedStyle(backdrop);
            ctx.fillStyle = backdropStyle.backgroundColor;
            ctx.fillRect(0, 0, nodeRect.width, nodeRect.height);
        }
        // Draw elements:
        const matches = node.querySelectorAll("label, input, button, h1, h2");
        matches.forEach((element)=>{
            ctx.save();
            const frame = element.getBoundingClientRect();
            const r = (0, $ba5a447b6ce1696c$exports.Rect).make(frame.x, frame.y, frame.width, frame.height);
            r.origin.x -= nodeRect.x;
            r.origin.y -= nodeRect.y;
            const style = window.getComputedStyle(element);
            ctx.font = style.font;
            const paddingTop = parseInt(style.paddingTop, 10);
            const paddingLeft = parseInt(style.paddingLeft, 10);
            const paddingBottom = parseInt(style.paddingBottom, 10);
            let text, textColor;
            if (element.tagName.toLowerCase() == "button") {
                ctx.fillStyle = style.backgroundColor;
                ctx.beginPath();
                ctx.roundRect(r.x, r.y, r.width, r.height, r.height * 0.5);
                ctx.fill();
            }
            r.origin.y += paddingTop;
            r.origin.x += paddingLeft;
            r.size.height -= paddingBottom;
            if (element.tagName.toLowerCase() == "input") {
                text = element.placeholder;
                textColor = "darkgray";
                // This needs to be forced on Firefox.
                ctx.letterSpacing = "-1px";
            } else {
                text = element.textContent;
                textColor = style.color;
            }
            if (text) {
                ctx.textBaseline = "middle";
                ctx.fillStyle = textColor;
                ctx.fillText(text, Math.floor(r.x), r.midY, r.width);
            }
            ctx.restore();
        });
    }
}
var $058cbf30945e9626$export$2e2bcd8739ae039 = $058cbf30945e9626$var$ContactPresentationSnapshotter;



class $0aa515be1dfe1bdf$var$NavigationHeader extends (0, $75862b29e2b1753f$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.node.innerHTML = `
      <div class="leading-items"></div>
      <div class="trailing-items"></div>
      
      <span class="background">
        ${`<span class="layer"></span>`.repeat(7)}
      </span>
    `;
    }
    makeNode(document) {
        return document.createElement("header");
    }
    configure(configuration) {
        const setItemsForContainer = (items, container)=>{
            container.innerHTML = "";
            for (const view of items)container.appendChild(view.node);
        };
        const { leading: leading, trailing: trailing } = configuration;
        setItemsForContainer(leading, this.node.querySelector(".leading-items"));
        setItemsForContainer(trailing, this.node.querySelector(".trailing-items"));
    }
}
var $0aa515be1dfe1bdf$export$2e2bcd8739ae039 = $0aa515be1dfe1bdf$var$NavigationHeader;



var $2e9c5578f92a680c$exports = {};

$parcel$export($2e9c5578f92a680c$exports, "getTextLength", () => $2e9c5578f92a680c$export$fb25d26502394eb4);
$parcel$export($2e9c5578f92a680c$exports, "getCaretOffset", () => $2e9c5578f92a680c$export$8f67eef0b2a37ece);
$parcel$export($2e9c5578f92a680c$exports, "isCaretAtStart", () => $2e9c5578f92a680c$export$4b527aed118f3e28);
$parcel$export($2e9c5578f92a680c$exports, "isCaretAtEnd", () => $2e9c5578f92a680c$export$5c4320976b16b199);
$parcel$export($2e9c5578f92a680c$exports, "isCaretOnFirstLine", () => $2e9c5578f92a680c$export$3c765aa202fca94e);
$parcel$export($2e9c5578f92a680c$exports, "isCaretOnLastLine", () => $2e9c5578f92a680c$export$8426fd97b26a59e0);
// https://gist.github.com/loilo/f873a88631e660c59a1d5ab757ca9b1e
function $2e9c5578f92a680c$export$fb25d26502394eb4(element) {
    let range = element.ownerDocument.createRange();
    range.selectNodeContents(element);
    return range.toString().length;
}
/**
 * Get the character offset the caret is currently at
 *
 * @param {Element} element
 * @return {number}
 */ function $2e9c5578f92a680c$export$8f67eef0b2a37ece(element) {
    let sel = element.ownerDocument.defaultView.getSelection();
    if (sel.rangeCount === 0) return 0;
    let range = element.ownerDocument.defaultView.getSelection().getRangeAt(0);
    let preCaretRange = range.cloneRange();
    preCaretRange.selectNodeContents(element);
    preCaretRange.setEnd(range.endContainer, range.endOffset);
    return preCaretRange.toString().length;
}
/**
 * Check if the caret is at the start of an element
 * Returns `false` when the caret is part of a selection
 *
 * @param {Element} element
 * @return {boolean}
 */ function $2e9c5578f92a680c$export$4b527aed118f3e28(element) {
    if (element.ownerDocument.activeElement !== element) return false;
    if (element.ownerDocument.defaultView.getSelection().getRangeAt(0).toString().length > 0) return false;
    return $2e9c5578f92a680c$export$8f67eef0b2a37ece(element) === 0;
}
/**
 * Check if the caret is at the end of an element
 * Returns `false` when the caret is part of a selection
 *
 * @param {Element} element
 * @return {boolean}
 */ function $2e9c5578f92a680c$export$5c4320976b16b199(element) {
    if (element.ownerDocument.activeElement !== element) return false;
    if (element.ownerDocument.defaultView.getSelection().getRangeAt(0).toString().length > 0) return false;
    return $2e9c5578f92a680c$export$8f67eef0b2a37ece(element) === $2e9c5578f92a680c$export$fb25d26502394eb4(element);
}
/**
 * Check if the caret is on the first line of an element
 * Returns `false` when the caret is part of a selection
 *
 * @param {Element} element
 * @return {boolean}
 */ function $2e9c5578f92a680c$export$3c765aa202fca94e(element) {
    if (element.ownerDocument.activeElement !== element) return false;
    // Get the client rect of the current selection
    let window = element.ownerDocument.defaultView;
    let selection = window.getSelection();
    if (selection.rangeCount === 0) return false;
    let originalCaretRange = selection.getRangeAt(0);
    // Bail if there is text selected
    if (originalCaretRange.toString().length > 0) return false;
    let originalCaretRect = originalCaretRange.getBoundingClientRect();
    // Create a range at the end of the last text node
    let startOfElementRange = element.ownerDocument.createRange();
    startOfElementRange.selectNodeContents(element);
    // The endContainer might not be an actual text node,
    // try to find the last text node inside
    let startContainer = startOfElementRange.endContainer;
    let startOffset = 0;
    while(startContainer.hasChildNodes() && !(startContainer instanceof Text))startContainer = startContainer.firstChild;
    startOfElementRange.setStart(startContainer, startOffset);
    startOfElementRange.setEnd(startContainer, startOffset);
    let endOfElementRect = startOfElementRange.getBoundingClientRect();
    return originalCaretRect.top === endOfElementRect.top;
}
/**
 * Check if the caret is on the last line of an element
 * Returns `false` when the caret is part of a selection
 *
 * @param {Element} element
 * @return {boolean}
 */ function $2e9c5578f92a680c$export$8426fd97b26a59e0(element) {
    if (element.ownerDocument.activeElement !== element) return false;
    // Get the client rect of the current selection
    let window = element.ownerDocument.defaultView;
    let selection = window.getSelection();
    if (selection.rangeCount === 0) return false;
    let originalCaretRange = selection.getRangeAt(0);
    // Bail if there is a selection
    if (originalCaretRange.toString().length > 0) return false;
    let originalCaretRect = originalCaretRange.getBoundingClientRect();
    // Create a range at the end of the last text node
    let endOfElementRange = document.createRange();
    endOfElementRange.selectNodeContents(element);
    // The endContainer might not be an actual text node,
    // try to find the last text node inside
    let endContainer = endOfElementRange.endContainer;
    let endOffset = 0;
    while(endContainer.hasChildNodes() && !(endContainer instanceof Text)){
        endContainer = endContainer.lastChild;
        endOffset = endContainer.length ?? 0;
    }
    endOfElementRange.setEnd(endContainer, endOffset);
    endOfElementRange.setStart(endContainer, endOffset);
    let endOfElementRect = endOfElementRange.getBoundingClientRect();
    return originalCaretRect.bottom === endOfElementRect.bottom;
}




const $0438ea9cc9ddfd7c$var$localizedGlobalName = "localized";
const $0438ea9cc9ddfd7c$var$LocalizedString = (key)=>window[$0438ea9cc9ddfd7c$var$localizedGlobalName][key] ?? key;
var $0438ea9cc9ddfd7c$export$2e2bcd8739ae039 = $0438ea9cc9ddfd7c$var$LocalizedString;




class $481456e5fad944a9$var$ContactFormView extends (0, $75862b29e2b1753f$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.node.innerHTML = `
    <label for="name">${(0, $0438ea9cc9ddfd7c$export$2e2bcd8739ae039)("contact.name-label")}</label>
    <input type="text" name="name" placeholder="Juan Mantiso" required />
    
    <label for="email">${(0, $0438ea9cc9ddfd7c$export$2e2bcd8739ae039)("contact.email-label")}</label>
    <input type="email" name="email" placeholder="${(0, $0438ea9cc9ddfd7c$export$2e2bcd8739ae039)("contact.email-placeholder")}" required />
    
    <label for="message">${(0, $0438ea9cc9ddfd7c$export$2e2bcd8739ae039)("contact.message-label")}</label>
    <span 
      class="textarea" 
      data-input-name="message"
      data-required=1
      role="textbox"
      aria-multiline="true"
      aria-labelledby="message"
      aria-required="true"
      contenteditable>
      <!-- Forgive me lord -->
    </span>
    `;
        this.handleTextAreas();
        this.node.addEventListener("submit", (event)=>{
            event.preventDefault();
        });
    }
    makeNode(document1) {
        return document1.createElement("form");
    }
    handleTextAreas() {
        // Textarea handling:
        const textareas = this.node.querySelectorAll(".textarea");
        for (const textarea of textareas){
            const name = textarea.getAttribute("data-input-name");
            const backingInputNode = document.createElement("input");
            backingInputNode.setAttribute("type", "text");
            backingInputNode.setAttribute("required", textarea.getAttribute("data-required"));
            backingInputNode.setAttribute("name", name);
            backingInputNode.tabIndex = -1;
            backingInputNode.style.height = "1px";
            backingInputNode.style.marginTop = "-1px";
            backingInputNode.style.overflow = "hidden";
            backingInputNode.style.opacity = "0";
            backingInputNode.onfocus = (event)=>{
                event.preventDefault();
                textarea.focus();
            };
            // Handle `input` to sync text into the form
            textarea.addEventListener("input", ()=>{
                // Update backing input:
                backingInputNode.value = textarea.textContent;
                // Notify:
                const { textInputDidChange: textInputDidChange } = this;
                if (textInputDidChange) {
                    const isAtEnd = (0, $2e9c5578f92a680c$exports).isCaretAtEnd(textarea);
                    textInputDidChange(this, {
                        input: backingInputNode,
                        isAtEnd: isAtEnd
                    });
                }
            }, false);
            // Handle `paste` to filter styled text
            textarea.addEventListener("paste", (e)=>{
                e.preventDefault();
                const text = e.clipboardData ? e.clipboardData.getData("text/plain") : "";
                if (document.queryCommandSupported?.("insertText")) return document.execCommand("insertText", false, text);
                const selection = document.getSelection();
                if (!selection) return;
                const range = selection.getRangeAt(0);
                range.deleteContents();
                range.insertNode(new Text(text));
                range.collapse(); // select nothing
                selection.removeAllRanges(); // position caret after inserted text
                selection.addRange(range); // show caret
            });
            this.node.insertBefore(backingInputNode, textarea);
        }
    }
    endEditing() {
        const form = this.node;
        for(let i = 0; i < form.elements.length; i++)form.elements[i].blur();
        // Clear textareas:
        const textareas = this.node.querySelectorAll(".textarea");
        textareas.forEach((textarea)=>{
            textarea.blur();
        });
        // Needed for some reason:
        window.getSelection().removeAllRanges();
    }
    get hasChanges() {
        const form = this.node;
        for(let i = 0; i < form.elements.length; i++){
            const element = form.elements[i];
            // Skip elements that don't have a value or aren't capable of change
            if (typeof element.value === "undefined" || element.type === "submit" || element.type === "button") continue;
            else if (element.value !== element.defaultValue) return true;
        }
        // If no differences were found
        return false;
    }
}
var $481456e5fad944a9$export$2e2bcd8739ae039 = $481456e5fad944a9$var$ContactFormView;



class $407ffebd6b13ddd4$var$ButtonType {
    static get plain() {
        return "plain-button";
    }
    static get rounded() {
        return "rounded-button";
    }
}
class $407ffebd6b13ddd4$var$ButtonRole {
    static get destructive() {
        return "destructive";
    }
}
class $407ffebd6b13ddd4$var$Button extends (0, $75862b29e2b1753f$export$2e2bcd8739ae039) {
    static get Type() {
        return $407ffebd6b13ddd4$var$ButtonType;
    }
    static get Role() {
        return $407ffebd6b13ddd4$var$ButtonRole;
    }
    constructor(configuration){
        super();
        const { type: type, role: role } = configuration;
        if (type) this.node.className = type;
        if (role) this.node.classList.add(role);
        this.node.addEventListener("click", this.triggerPrimaryAction.bind(this));
    }
    makeNode(document) {
        return document.createElement("button");
    }
    triggerPrimaryAction(event) {
        const { primaryAction: primaryAction } = this;
        if (primaryAction) primaryAction(event);
    }
    set text(text) {
        this.node.textContent = text;
    }
    get text() {
        return this.node.textContent;
    }
}
var $407ffebd6b13ddd4$export$2e2bcd8739ae039 = $407ffebd6b13ddd4$var$Button;





class $81c2e2b134d1da1c$var$DeleteConfirmationOverlay extends (0, $75862b29e2b1753f$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.node.className = "delete-confirmation-overlay";
        this.node.innerHTML = `
      <div class="backdrop"></div>
      <div class="delete-button-wrapper"></div>
    `;
        const deleteButton = new (0, $407ffebd6b13ddd4$export$2e2bcd8739ae039)({
            type: (0, $407ffebd6b13ddd4$export$2e2bcd8739ae039).Type.rounded,
            role: (0, $407ffebd6b13ddd4$export$2e2bcd8739ae039).Role.destructive
        });
        deleteButton.text = (0, $0438ea9cc9ddfd7c$export$2e2bcd8739ae039)("contact.delete-button");
        deleteButton.primaryAction = (event)=>{
            event.stopPropagation();
            this.actions?.didDelete();
        };
        const deleteContainerNode = this.node.querySelector(".delete-button-wrapper");
        this.deleteContainerNode = deleteContainerNode;
        deleteContainerNode.appendChild(deleteButton.node);
    }
    show(options) {
        const { containerNode: containerNode, sourceNode: sourceNode } = options;
        if (this.presentation) return;
        const containerNodeRect = containerNode.getBoundingClientRect();
        const sourceNodeRect = sourceNode.getBoundingClientRect();
        const { deleteContainerNode: deleteContainerNode } = this;
        deleteContainerNode.style.top = `${sourceNodeRect.y - containerNodeRect.y}px`;
        deleteContainerNode.style.left = `${sourceNodeRect.x - containerNodeRect.x}px`;
        deleteContainerNode.style.maxWidth = `${containerNodeRect.width}px`;
        containerNode.appendChild(this.node);
        this.presentation = {
            ...options
        };
        const present = ()=>{
            this.node.classList.add("presented");
            const animation = deleteContainerNode.animate([
                {
                    maxWidth: `${sourceNodeRect.width}px`,
                    opacity: 0
                },
                {
                    maxWidth: `${sourceNodeRect.width}px`,
                    opacity: 1,
                    offset: 0.05
                },
                {
                    maxWidth: `${containerNodeRect.width}px`,
                    opacity: 1
                }
            ], {
                duration: 800,
                easing: "ease-in"
            });
            animation.finished.then(()=>{
                this.addSelectOutsideHandler();
            });
        };
        window.requestAnimationFrame(present);
    }
    dismiss() {
        const { sourceNode: sourceNode } = this.presentation;
        const { deleteContainerNode: deleteContainerNode } = this;
        const sourceNodeRect = sourceNode.getBoundingClientRect();
        const dismiss = ()=>{
            this.node.classList.remove("presented");
            const animation = deleteContainerNode.animate([
                {
                    maxWidth: sourceNode.style.maxWidth,
                    opacity: 1
                },
                {
                    maxWidth: `${sourceNodeRect.width}px`,
                    opacity: 1,
                    offset: 0.95
                },
                {
                    maxWidth: `${sourceNodeRect.width}px`,
                    opacity: 0
                }
            ], {
                duration: 800,
                easing: "ease-out",
                fill: "forwards"
            });
            animation.finished.then(()=>{
                this.node.remove();
                this.presentation = undefined;
                if (this.didDismiss) this.didDismiss();
            });
        };
        window.requestAnimationFrame(dismiss);
        if (this.removeSelectOusideHandler) {
            this.removeSelectOusideHandler();
            this.removeSelectOusideHandler = undefined;
        }
    }
    didSelectOutside(event) {
        if (event.target == this.deleteContainerNode.querySelector("button")) return;
        this.actions?.didCancel();
    }
    addSelectOutsideHandler() {
        const event = "click";
        const handler = (event)=>{
            this.didSelectOutside(event);
        };
        document.addEventListener(event, handler);
        this.removeSelectOusideHandler = ()=>{
            document.removeEventListener(event, handler);
        };
    }
}
var $81c2e2b134d1da1c$export$2e2bcd8739ae039 = $81c2e2b134d1da1c$var$DeleteConfirmationOverlay;





class $602c05ccaaaf4961$var$SentConfirmationOverlay extends (0, $75862b29e2b1753f$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.node.className = "sent-confirmation-overlay";
        this.node.innerHTML = `
      <div class="backdrop"></div>
      
      <div class="content-wrapper">
        <h1>${(0, $0438ea9cc9ddfd7c$export$2e2bcd8739ae039)("contact.sent-confirmation-title")}</h1>
        <h2>${(0, $0438ea9cc9ddfd7c$export$2e2bcd8739ae039)("contact.sent-confirmation-subtitle")}</h2>
      </div>
    `;
        const dismissButton = new (0, $407ffebd6b13ddd4$export$2e2bcd8739ae039)({
            type: (0, $407ffebd6b13ddd4$export$2e2bcd8739ae039).Type.rounded
        });
        dismissButton.text = (0, $0438ea9cc9ddfd7c$export$2e2bcd8739ae039)("contact.done-button");
        dismissButton.primaryAction = (event)=>{
            this.primaryAction(event);
        };
        const contentWrapper = this.node.querySelector(".content-wrapper");
        contentWrapper.appendChild(dismissButton.node);
    }
    show(options, completion) {
        const { containerNode: containerNode } = options;
        const contentNode = this.node.querySelector(".content-wrapper");
        containerNode.appendChild(this.node);
        const present = ()=>{
            this.node.classList.add("presented");
            const contentNodeRect = contentNode.getBoundingClientRect();
            const animation = contentNode.animate([
                {
                    transform: new DOMMatrix().scale(0.8),
                    opacity: 0,
                    filter: "blur(20px)"
                },
                {
                    transform: new DOMMatrix(),
                    opacity: 1,
                    filter: "blur(0px)"
                }
            ], {
                duration: 800,
                easing: "ease-out"
            });
            if (completion) animation.finished.then(completion);
        };
        window.requestAnimationFrame(present);
    }
    dismiss() {
    // Unimplemented
    }
}
var $602c05ccaaaf4961$export$2e2bcd8739ae039 = $602c05ccaaaf4961$var$SentConfirmationOverlay;



class $0fb0ee49c84191b5$var$ShakeAnimator {
    constructor(){
        const iterations = 200;
        const keyframes = [];
        const e = 2.5;
        let position = 0;
        for(let t = 0; t < iterations; t += 1){
            position = 42 * Math.pow(e, -0.022 * t) * Math.sin(0.12 * t);
            const transform = new DOMMatrix().translate(position, 0);
            keyframes.push({
                transform: transform
            });
        }
        this.keyframes = keyframes;
    }
    animate(target, completion) {
        const { keyframes: keyframes } = this;
        const animation = target.animate(keyframes, {
            duration: 600
        });
        if (completion) animation.finished.then(completion);
    }
}
var $0fb0ee49c84191b5$export$2e2bcd8739ae039 = $0fb0ee49c84191b5$var$ShakeAnimator;




class $acacc3fd0566a9ca$var$APIClient {
    constructor({ baseURL: baseURL } = options){
        this.baseURL = baseURL;
    }
    async submitContact({ name: name, email: email, message: message } = params) {
        const path = "/api/hello";
        const data = {
            sender: {
                name: name,
                email: email
            },
            message: message
        };
        const requestURL = new URL(path, this.baseURL);
        let response;
        try {
            response = await fetch(requestURL, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(data)
            });
        } catch (error) {
            console.error("[APIClient] An error has ocurred", error);
        }
        if (response && response.ok) return response;
        else return undefined;
    }
}
var $acacc3fd0566a9ca$export$2e2bcd8739ae039 = $acacc3fd0566a9ca$var$APIClient;


let $b2f21551cdd6a56a$var$defaultBaseURL = "https://api.mantisa.com/";
const $b2f21551cdd6a56a$var$sharedClient = new (0, $acacc3fd0566a9ca$export$2e2bcd8739ae039)({
    baseURL: $b2f21551cdd6a56a$var$defaultBaseURL
});
(0, $acacc3fd0566a9ca$export$2e2bcd8739ae039).sharedClient = $b2f21551cdd6a56a$var$sharedClient;


class $cc3d4474bd75312e$var$EditingState {
    static editable = 0;
    static intermediate = 1;
    static sent = 2;
}
class $cc3d4474bd75312e$export$2aa93a6f36b4689c extends (0, $75862b29e2b1753f$export$2e2bcd8739ae039) {
    makeNode(document1) {
        return document1.createElement("dialog");
    }
    constructor(){
        super();
        this.node.classList = "sheet-dialog";
        this.node.innerHTML = `
    <div class="sheet-backdrop"></div>
    <div class="sheet-transitioning-container"></div>
    
    <div class="sheet">
      <div class="sheet-container">
        <div class="sheet-content"></div>
      </div>
    </div>
    
    <div class="sheet-hidden">
      <span id="label">Contacto</span>
    </div>
    `;
        this.editingState = $cc3d4474bd75312e$var$EditingState.editable;
        // Accessibility labels:
        this.node.setAttribute("role", "dialog");
        this.node.setAttribute("aria-labelledby", "label");
        this.node.setAttribute("aria-modal", true);
        // Actions:
        const dismissButton = new (0, $407ffebd6b13ddd4$export$2e2bcd8739ae039)({
            type: (0, $407ffebd6b13ddd4$export$2e2bcd8739ae039).Type.plain
        });
        dismissButton.node.ariaLabel = (0, $0438ea9cc9ddfd7c$export$2e2bcd8739ae039)("contact.close-button");
        dismissButton.node.innerHTML = `
    <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg">
      <use href="#x-close" />
    </svg>
    `;
        dismissButton.primaryAction = (event)=>{
            // Cancel if not editing:
            if (this.editingState != $cc3d4474bd75312e$var$EditingState.editable) return;
            // Cancel a pending confirmation if needed:
            if (this.pendingConfirmation) {
                this.pendingConfirmation.dismiss();
                return;
            }
            this.formView.endEditing();
            // Dismiss right away if has no edits:
            if (!this.formView.hasChanges) {
                this.dismiss();
                return;
            }
            const confirmation = new (0, $81c2e2b134d1da1c$export$2e2bcd8739ae039)();
            confirmation.didDismiss = ()=>{
                if (confirmation == this.pendingConfirmation) this.pendingConfirmation = undefined;
            };
            confirmation.actions = {
                didDelete: ()=>{
                    this.dismiss((0, $76a9e1a621d3da16$export$2e2bcd8739ae039).TransitionStyle.destroy);
                },
                didCancel: ()=>{
                    confirmation.dismiss();
                }
            };
            confirmation.show({
                containerNode: this.node.querySelector(".sheet-container"),
                sourceNode: dismissButton.node
            });
            this.pendingConfirmation = confirmation;
        };
        const submitButton = new (0, $407ffebd6b13ddd4$export$2e2bcd8739ae039)({
            type: (0, $407ffebd6b13ddd4$export$2e2bcd8739ae039).Type.rounded
        });
        submitButton.text = (0, $0438ea9cc9ddfd7c$export$2e2bcd8739ae039)("contact.send-button");
        submitButton.node.ariaLabel = (0, $0438ea9cc9ddfd7c$export$2e2bcd8739ae039)("contact.send-button");
        submitButton.primaryAction = (event)=>{
            this.submit();
        };
        // Configure header:
        const sheetContent = this.node.querySelector(".sheet-content");
        const headerView = new (0, $0aa515be1dfe1bdf$export$2e2bcd8739ae039)();
        headerView.configure({
            leading: [
                dismissButton
            ],
            trailing: [
                submitButton
            ]
        });
        sheetContent.appendChild(headerView.node);
        this.headerView = headerView;
        // Configure form:
        const formView = new (0, $481456e5fad944a9$export$2e2bcd8739ae039)();
        // Scroll to bottom if caret at end because of some WebKit bug that doesn't take into account the element's text area bottom padding:
        formView.textInputDidChange = (sender, context)=>{
            if (context.isAtEnd) sheetContent.scrollTop = sheetContent.scrollHeight;
        };
        sheetContent.appendChild(formView.node);
        this.formView = formView;
        // Customize the `cancel` dialog behavior so we call the appropriate custom dismiss mechanism.
        const dialog = this.node;
        dialog.addEventListener("cancel", (event)=>{
            event.preventDefault();
            dismissButton.triggerPrimaryAction();
        }, true);
        // Handle `touchmove`:
        // This is a nightmare, MobileSafari does way too much magic stuff to avoid `fixed` elements hiding under the keyboard. To make matters worse, `overscroll-behavior` isn't reliable on MobileSafari and thus the whole page will be scrolled under the sheet.
        // We'll try to hide the keyboard and prevent scrolling whatever possible.
        const canScroll = (element)=>element.scrollHeight > element.clientHeight;
        this.node.addEventListener("touchmove", (event)=>{
            const { activeElement: activeElement } = document;
            const hasFocusedElement = activeElement && sheetContent.contains(activeElement);
            let triggerEventPreventDefault = false;
            // If there's a focused element and the user is editing, we don't want them scrolling:
            if (hasFocusedElement) triggerEventPreventDefault = true;
            else // If not editing and scrolling is possible, prevent only if touching inside the content:
            if (canScroll(sheetContent)) {
                const isInside = sheetContent.contains(event.target);
                if (!isInside) triggerEventPreventDefault = true;
            } else triggerEventPreventDefault = true;
            // Prevent if needed:
            if (triggerEventPreventDefault) event.preventDefault();
            formView.endEditing();
        });
    }
    submit() {
        const form = this.formView.node;
        const didSatisfy = form.checkValidity();
        this.formView.endEditing();
        if (!didSatisfy) {
            const animator = new (0, $0fb0ee49c84191b5$export$2e2bcd8739ae039)();
            animator.animate(this.node.querySelector(".sheet"), ()=>{
                form.reportValidity();
            });
            return;
        }
        this.node.querySelector(".sheet").classList.add("intermediate-progress");
        this.editingState = $cc3d4474bd75312e$var$EditingState.intermediate;
        (async ()=>{
            const parameters = {};
            const data = new FormData(form);
            data.forEach(function(value, key) {
                parameters[key] = value;
            });
            const response = await (0, $acacc3fd0566a9ca$export$2e2bcd8739ae039).sharedClient.submitContact(parameters);
            if (!response) {
                this.editingState = $cc3d4474bd75312e$var$EditingState.editable;
                this.node.querySelector(".sheet").classList.remove("intermediate-progress");
                alert((0, $0438ea9cc9ddfd7c$export$2e2bcd8739ae039)("contact.cannot-send-message-alert"));
                return;
            }
            // Present confirmation:
            const confirmation = new (0, $602c05ccaaaf4961$export$2e2bcd8739ae039)();
            confirmation.primaryAction = (event)=>{
                this.dismiss();
            };
            confirmation.show({
                containerNode: this.node.querySelector(".sheet-container")
            }, ()=>{
                this.formView.removeFromSuperview();
                this.headerView.removeFromSuperview();
                this.node.querySelector(".sheet").classList.remove("intermediate-progress");
                this.transitionCoordinator.snapshotter = (0, $058cbf30945e9626$export$2e2bcd8739ae039).sent;
            });
        })();
    }
    // - Presentation
    show(options) {
        if (this.transitionCoordinator) throw new Error("State inconsistency error, view already shown.");
        const { containerElement: containerElement, sourceElement: sourceElement } = options;
        // TODO: `sourceElement` is optional, do a simple transition if that's the case
        if (!sourceElement) throw new Error("Not providing a `sourceElement` isn't supported.");
        this.node.querySelector(".sheet-container").style.visibility = "hidden";
        containerElement.appendChild(this.node);
        const dialog = this.node;
        dialog.showModal();
        const coordinatorOptions = {
            containerNode: this.node.querySelector(".sheet-transitioning-container"),
            sheetNode: this.node.querySelector(".sheet-container"),
            sourceNode: sourceElement
        };
        const coordinator = new (0, $76a9e1a621d3da16$export$2e2bcd8739ae039)(coordinatorOptions);
        coordinator.snapshotter = (0, $058cbf30945e9626$export$2e2bcd8739ae039).contact;
        coordinator.delegate = this;
        coordinator.show();
        this.transitionCoordinator = coordinator;
    }
    dismiss(transitionStyle) {
        if (this.transitionCoordinator.isTransitioning) return;
        this.editingState = $cc3d4474bd75312e$var$EditingState.intermediate;
        this.transitionCoordinator.dismiss(transitionStyle);
    }
    // - SheetTransitionCoordinator
    sheetTransitionCoordinatorWillBegin(coordinator, direction) {
        const { node: node } = this;
        if (direction) node.querySelector(".sheet-backdrop").classList.add("appear");
        else node.querySelector(".sheet-backdrop").classList.remove("appear");
        node.querySelector(".sheet-transitioning-container").style.display = "";
    }
    sheetTransitionCoordinatorDidComplete(coordinator, direction) {
        const { node: node } = this;
        if (direction) {
            node.querySelector(".sheet-container").style.visibility = "";
            node.querySelector(".sheet-transitioning-container").style.display = "none";
            // Focus first button for screen readers:
            node.querySelector("button")?.focus();
        } else {
            const dialog = this.node;
            dialog.close();
            this.removeFromSuperview();
        }
    }
}


class $35da740d59af89ba$var$MainActions {
    didSelectContact(event) {
        event?.preventDefault();
        const sheet = new (0, $cc3d4474bd75312e$export$2aa93a6f36b4689c)();
        const options = {
            containerElement: document.querySelector("main"),
            sourceElement: event?.target
        };
        sheet.show(options);
    }
    didSelectHome(event) {
        const threshold = 44.0;
        if (window.pageYOffset > threshold) {
            event?.preventDefault();
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            });
        }
    }
}
class $35da740d59af89ba$var$Mantisa extends (0, $1553bf3484a166d1$export$2e2bcd8739ae039) {
    documentDidLoad(document1) {
        const actions = new $35da740d59af89ba$var$MainActions();
        const actionQueryMap = {
            didSelectContact: ".action-contact",
            didSelectHome: "a.mark"
        };
        for (const [name, query] of Object.entries(actionQueryMap)){
            const fn = actions[name].bind(actions);
            document1.querySelectorAll(query).forEach((match)=>{
                match.addEventListener("click", fn);
            });
        }
    }
}
window.app = new $35da740d59af89ba$var$Mantisa(document);


//# sourceMappingURL=404.956f3995.js.map
